var _tspan, _tspan2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError429(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-16"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.33,66.83a14.57,14.57,0,0,1,20-13.39,17.62,17.62,0,0,1,33,3.9,15.15,15.15,0,0,1-1,30.27H157.16a10.74,10.74,0,0,1-3.83-20.78Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.69,87.7a5.57,5.57,0,0,1,7.64-5.11,6.71,6.71,0,0,1,12.59,1.49,5.78,5.78,0,0,1-.38,11.54H66.15a4.09,4.09,0,0,1-1.46-7.92Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.86,57.82a8.93,8.93,0,0,0-12.28-8.2A10.79,10.79,0,0,0,401.35,52a9.29,9.29,0,0,0,.6,18.56h29.56a6.59,6.59,0,0,0,2.35-12.74Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.68,
    y: 298.41,
    width: 31.73,
    height: 55.42,
    rx: 5.04,
    transform: "translate(546.79 -148.98) rotate(68.62)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.92,330.63a.62.62,0,0,1-.19,0l-27.05-5.24a1,1,0,1,1,.38-2l26.43,5.12,15.93-21.7a1,1,0,0,1,1.4-.22A1,1,0,0,1,401,308l-16.31,22.21A1,1,0,0,1,383.92,330.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.39,
    y: 266.15,
    width: 31.73,
    height: 55.42,
    rx: 5.04,
    transform: "translate(409.66 267.97) rotate(104.05)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.34,298.52a1,1,0,0,1-.73-.31l-19-19.95a1,1,0,0,1,1.45-1.39l18.57,19.49,25.56-8.44a1,1,0,0,1,1.27.64,1,1,0,0,1-.64,1.27l-26.16,8.64A.93.93,0,0,1,99.34,298.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.17,174.1H357.88a10.53,10.53,0,0,0-10.5,10.5v39.88l9.77-9.77h51a10.52,10.52,0,0,0,10.49-10.49V184.6A10.52,10.52,0,0,0,408.17,174.1Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.42,188.48H358.9a1.75,1.75,0,0,1-1.75-1.75h0A1.76,1.76,0,0,1,358.9,185h47.52a1.76,1.76,0,0,1,1.75,1.75h0A1.75,1.75,0,0,1,406.42,188.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.42,196.54H358.9a1.76,1.76,0,0,1-1.75-1.75h0A1.76,1.76,0,0,1,358.9,193h47.52a1.76,1.76,0,0,1,1.75,1.75h0A1.76,1.76,0,0,1,406.42,196.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.24,204.6H358.9a1.76,1.76,0,0,1-1.75-1.75h0a1.76,1.76,0,0,1,1.75-1.75h31.34a1.76,1.76,0,0,1,1.75,1.75h0A1.76,1.76,0,0,1,390.24,204.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.94,193.86h40.64a8.51,8.51,0,0,1,8.48,8.48v25.73l-7.9-7.89H72.94a8.5,8.5,0,0,1-8.48-8.48v-9.36A8.5,8.5,0,0,1,72.94,193.86Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.35,205.48h38.4a1.41,1.41,0,0,0,1.41-1.41h0a1.41,1.41,0,0,0-1.41-1.41H74.35a1.41,1.41,0,0,0-1.41,1.41h0A1.41,1.41,0,0,0,74.35,205.48Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.43,212h25.32a1.42,1.42,0,0,0,1.41-1.42h0a1.41,1.41,0,0,0-1.41-1.41H87.43A1.42,1.42,0,0,0,86,210.59h0A1.43,1.43,0,0,0,87.43,212Z",
    style: {
      fill: "#e6e6e6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-16"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-16",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--sign-2--inject-16"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "409.16 151.88 406.79 151.37 404.33 151.08 401.94 150.47 399.5 150.07 397.07 149.64 394.64 149.21 392.22 148.7 389.79 148.24 387.36 147.81 384.93 147.36 382.5 146.91 380.08 146.45 377.68 145.86 375.26 145.37 372.85 144.85 370.38 144.58 367.99 143.92 365.55 143.51 363.11 143.16 360.69 142.64 358.26 142.21 355.85 141.68 353.4 141.34 350.99 140.78 348.56 140.34 346.11 139.94 343.72 139.32 341.27 138.93 338.86 138.39 336.43 137.95 333.99 137.53 331.56 137.06 329.15 136.52 326.72 136.07 324.3 135.59 321.87 135.13 319.44 134.64 316.98 134.37 314.57 133.82 312.14 133.31 309.72 132.83 307.27 132.48 304.85 131.97 302.44 131.43 300.02 130.9 297.58 130.51 295.14 130.13 292.71 129.67 290.3 129.11 287.88 128.64 285.43 128.23 283.02 127.68 280.57 127.33 278.13 126.9 275.73 126.28 273.29 125.87 270.84 125.48 268.4 125.06 265.98 124.56 263.54 124.13 261.13 123.53 258.68 123.17 256.25 122.64 253.81 122.19 251.43 121.66 251.81 119.8 252.18 117.91 252.47 115.99 252.87 114.1 253.07 112.17 253.46 110.27 254 108.41 254.27 106.49 254.63 104.59 254.88 102.67 255.27 100.78 255.62 98.88 256.19 97.02 256.55 95.12 256.96 93.23 257.21 91.31 257.5 89.39 257.89 87.5 258.22 85.59 258.52 83.68 258.99 81.79 259.45 79.91 259.77 78 259.98 76.07 260.57 74.21 260.78 72.28 261.08 70.36 261.71 68.51 261.98 66.62 264.36 67.06 266.8 67.43 269.21 67.92 271.64 68.34 274.05 68.89 276.46 69.43 278.91 69.8 281.31 70.36 283.74 70.86 286.18 71.21 288.59 71.75 291.03 72.14 293.45 72.63 295.89 73 298.29 73.61 300.75 73.9 303.14 74.54 305.59 74.89 308.02 75.36 310.45 75.79 312.84 76.44 315.31 76.7 317.72 77.22 320.15 77.69 322.56 78.26 324.98 78.73 327.42 79.16 329.87 79.5 332.3 79.95 334.69 80.61 337.15 80.89 339.57 81.39 341.99 81.92 344.42 82.34 346.85 82.82 349.28 83.28 351.72 83.66 354.15 84.14 356.54 84.78 358.98 85.23 361.4 85.71 363.83 86.19 366.28 86.53 368.71 86.96 371.12 87.54 373.54 88.02 375.96 88.53 378.42 88.84 380.84 89.33 383.28 89.72 385.71 90.21 388.12 90.77 390.56 91.16 392.97 91.73 395.4 92.19 397.87 92.5 400.26 93.17 402.71 93.54 405.14 94.01 407.58 94.41 409.99 95 412.45 95.35 414.88 95.82 417.31 96.35 419.7 96.83 419.24 98.67 419.04 100.6 418.67 102.5 418.32 104.4 417.82 106.28 417.53 108.19 417.21 110.1 416.88 112 416.61 113.92 416.2 115.81 415.86 117.71 415.5 119.61 415.05 121.49 414.74 123.4 414.31 125.29 414.05 127.21 413.45 129.06 413.19 130.98 412.91 132.9 412.51 134.79 411.98 136.66 411.68 138.58 411.43 140.5 411.05 142.4 410.69 144.3 410.37 146.21 409.85 148.09 409.52 150 409.16 151.88",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.16,152.34h-.1l-2.37-.51-2.41-.29-2.46-.61-7.26-1.26-4.85-1L380,146.91l-2.42-.6-4.82-1-2.42-.27-2.46-.67-2.39-.4-2.44-.35-2.45-.53-2.41-.42-2.43-.54-2.42-.34-2.45-.57-4.84-.83-2.44-.63-2.4-.38-2.44-.54-7.28-1.32-2.43-.55-9.7-1.88-2.42-.27-4.88-1-2.42-.49-2.43-.34-7.27-1.59-4.86-.77-2.45-.46-2.42-.56-2.41-.47-2.43-.41-2.44-.55-2.42-.34-2.45-.44-2.44-.63-7.29-1.2-2.44-.51-2.42-.43L261,124l-2.41-.35-2.45-.52-2.43-.46-2.4-.53a.46.46,0,0,1-.35-.54l.74-3.75.3-1.9.4-1.92.2-1.88.39-1.94.55-1.9.26-1.85.36-1.92.24-1.89.75-3.82.58-1.91L256.1,95l.41-1.91.53-3.81.4-1.92.63-3.8.93-3.8.31-1.87.21-1.91.61-2,.19-1.84.3-1.94.66-1.93.24-1.8a.46.46,0,0,1,.19-.31.48.48,0,0,1,.35-.08l2.38.43,2.43.38,2.43.49,2.42.42L276.56,69l2.41.36,2.45.58,2.41.49,2.42.34,2.44.55,2.41.38,2.44.5,2.42.36,2.44.62,2.4.29,2.46.65,2.4.33,4.87.9L313,76l2.39.24,4.88,1,2.43.57,4.84.9,2.43.34,2.45.45,2.43.66,2.39.28,4.89,1,2.41.41,4.86.94,2.43.38,2.45.48,2.42.66,7.26,1.39,2.42.35,2.45.42,2.43.59,4.83,1,2.42.31,2.46.48,2.42.4,2.45.49,2.42.56,2.42.39,2.44.57,2.41.46,2.43.3,2.46.68,2.4.36,2.44.48,2.43.39,2.45.6,2.41.34,2.46.48,4.82,1a.49.49,0,0,1,.3.21.45.45,0,0,1,.06.36l-.46,1.84-.19,1.87-.73,3.84-.5,1.9L417.06,114l-.41,1.92-.7,3.8-.45,1.9-.31,1.88-.43,1.91-.26,1.88-.61,1.93-.52,3.77-.41,1.92-.54,1.9-.54,3.77-.74,3.83-.32,1.9-.52,1.92-.69,3.75a.45.45,0,0,1-.2.3A.46.46,0,0,1,409.16,152.34ZM252,121.31l1.94.43,2.43.45,2.44.53,2.42.35,2.45.61,2.41.42,2.43.51,7.31,1.21,2.45.63,2.4.43,2.44.34,2.45.56,2.41.4,2.44.48,2.42.56,2.41.45,4.88.77,7.26,1.59,2.42.34,4.88,1,2.42.55,2.41.26,9.75,1.89,2.43.54,2.41.47,4.87.86,2.43.54,2.41.38,2.44.63,4.84.83,2.43.57,2.41.33,2.45.54,2.41.43,2.43.52,2.42.35,2.45.41,2.44.66,2.39.27,4.87,1,2.42.59,19.39,3.61L402,150l2.43.61,2.4.28,2,.42.61-3.32.52-1.92.68-3.78.37-1.9.25-1.89.3-1.93.54-1.92.4-1.86L413,129l.6-1.93.26-1.84.43-1.93.31-1.88.45-1.92,1.1-5.68.27-1.88.94-5.73.51-1.93.72-3.77.19-1.89.36-1.44-6.78-1.38-2.44-.35-2.45-.59-2.41-.4L402.62,94l-2.43-.37-2.45-.68-2.39-.29-2.46-.47-2.43-.57L388,91.22l-2.44-.56-2.41-.48-2.43-.4-2.43-.48L375.9,89,371,88l-2.42-.59L366.2,87l-2.44-.35-7.3-1.41L354,84.58l-2.4-.47-2.42-.38-7.3-1.35-4.85-1-2.43-.28-2.46-.66L329.78,80l-2.43-.34-4.88-.91L320,78.14l-4.83-1-2.42-.25-2.46-.67-2.39-.41-2.44-.48L303.08,75l-2.45-.65-2.4-.28-2.45-.63-2.4-.35-2.44-.5-2.42-.39-2.44-.54-2.41-.34-2.45-.5-2.42-.58-2.41-.36-4.85-1.09-2.41-.42-2.42-.49-2.42-.37-1.92-.35-.2,1.41-.66,1.94-.27,1.84L261,74.26l-.61,1.95-.19,1.84L259.9,80l-.93,3.8-.62,3.79-.4,1.91-.53,3.8L257,95.22l-.36,1.89-.58,1.9-.33,1.85-.4,1.91-.24,1.88-.36,1.93-.27,1.89-.56,1.93-.37,1.86-.2,1.89-.41,1.94-.29,1.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "256.96 93.23 256.55 95.12 256.19 97.02 255.62 98.88 255.27 100.78 254.88 102.67 254.63 104.59 254.27 106.49 254 108.41 253.46 110.27 253.07 112.17 252.87 114.1 252.47 115.99 252.18 117.91 251.81 119.8 251.43 121.66 253.81 122.19 256.25 122.64 258.68 123.17 261.13 123.53 263.54 124.13 256.96 93.23",
    style: {
      fill: "#263238",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.98, 0.2, -0.2, 0.98, 282.54, 94.99)",
    style: {
      fontSize: "21.068910598754883px",
      fill: "#FF0000",
      fontFamily: "Arial-Black, Arial",
      fontWeight: 800
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    style: {
      letterSpacing: "-0.06786927278098115em"
    }
  }, "T"), _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 13.79,
    y: 0
  }, "oo many")), /*#__PURE__*/React.createElement("tspan", {
    x: 4.98,
    y: 20.37,
    style: {
      letterSpacing: "0.01611851774600389em"
    }
  }, "r"), _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 14.68,
    y: 20.37
  }, "equests")))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Envelope--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M277.25,171.14A1263.49,1263.49,0,0,0,152.8,231a1511.06,1511.06,0,0,1,216.08,35.22A1105.32,1105.32,0,0,0,277.25,171.14Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.75,226.94A1520.28,1520.28,0,0,1,360.36,259c11,2.56,17.78,11.36,15.1,19.41L346.6,365.49c-2.71,8.05-12.82,12.67-22.54,10.42a1350,1350,0,0,0-174.3-28.41c-10-1-17.54-8.47-16.77-16.83q4.37-45.19,8.72-90.38C142.48,231.93,152.42,225.85,163.75,226.94Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.75,226.94A1520.28,1520.28,0,0,1,360.36,259c11,2.56,17.78,11.36,15.1,19.41L346.6,365.49c-2.71,8.05-12.82,12.67-22.54,10.42a1350,1350,0,0,0-174.3-28.41c-10-1-17.54-8.47-16.77-16.83q4.37-45.19,8.72-90.38C142.48,231.93,152.42,225.85,163.75,226.94Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.77,347.51a1346,1346,0,0,1,174.28,28.41,21.62,21.62,0,0,0,12.82-.91,988.8,988.8,0,0,0-84.09-88.3,1130,1130,0,0,0-114.62,55.91A20.26,20.26,0,0,0,149.77,347.51Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.77,347.51a1346,1346,0,0,1,174.28,28.41,21.62,21.62,0,0,0,12.82-.91,988.8,988.8,0,0,0-84.09-88.3,1130,1130,0,0,0-114.62,55.91A20.26,20.26,0,0,0,149.77,347.51Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.19,308.38a1230.07,1230.07,0,0,1,121.61-45,23.85,23.85,0,0,0-9.44-4.41,1518.41,1518.41,0,0,0-196.6-32.05,25.78,25.78,0,0,0-10.64,1.14A1086.3,1086.3,0,0,1,248.19,308.38Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.19,308.38a1230.07,1230.07,0,0,1,121.61-45,23.85,23.85,0,0,0-9.44-4.41,1518.41,1518.41,0,0,0-196.6-32.05,25.78,25.78,0,0,0-10.64,1.14A1086.3,1086.3,0,0,1,248.19,308.38Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M275.9,129.91c-8.35,3.59-8.41,15.71-2.32,13.31S280.93,127.75,275.9,129.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.01 339.37 217.1 334.86 217.23 346.81 205.46 350.59 203.01 339.37",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.01 339.37 217.11 334.86 217.18 341.56 204.38 345.66 203.01 339.37",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.79,349.09l-1.38.75a2.8,2.8,0,0,1-2.65,0h0l-.43,1a2.79,2.79,0,0,1-1.23,1.35L197.21,362.4a8.25,8.25,0,0,1-1.33-4.11s8.06-4.93,8.62-8.38a.71.71,0,0,1,.48-.57c1.78-.53,8.7-2.74,11.64-5.86a.85.85,0,0,1,1.35.18A46.82,46.82,0,0,0,221.79,349.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205,350.14h0c-.14,0-3.23-.32-4.05-1.36a.93.93,0,0,1-.22-.72.75.75,0,0,1,.56-.67c1-.25,3.11,1.29,3.91,2.4a.21.21,0,0,1,0,.24A.21.21,0,0,1,205,350.14Zm-3.47-2.33a.34.34,0,0,0-.15,0c-.1,0-.19.07-.22.29a.47.47,0,0,0,.12.38c.48.61,2.14,1,3.18,1.13A5.81,5.81,0,0,0,201.54,347.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.64,352.54a.92.92,0,0,1-.66-.25.73.73,0,0,1-.21-.84c.38-.95,2.87-1.75,4.23-1.75a.23.23,0,0,1,.21.13.23.23,0,0,1,0,.24c-.09.1-2.16,2.41-3.49,2.47Zm2.82-2.36c-1.31.16-3,.83-3.28,1.43a.29.29,0,0,0,.11.35.46.46,0,0,0,.38.13C202.45,352.06,203.72,350.93,204.46,350.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.55,226.93l3.65,13c5.39,19.17-4.55,39.88-21.9,45.68-10.13,3.38-24,3.91-32.1,5.73,4.32,14.44,5.48,33.53,5.68,47.36l-19.66,5.09c-5.15-16.16-13.21-41.37-18.57-57.63a16.14,16.14,0,0,1,4.15-16.66C209.94,249,266.55,226.93,266.55,226.93Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "248.95 361.35 261.69 353.84 264.46 365.47 253.82 371.76 248.95 361.35",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "248.95 361.35 261.7 353.84 263.25 360.35 251.68 367.18 248.95 361.35",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.31,369.8l-1.39.74a2.78,2.78,0,0,1-2.64,0h0l-.45,1a2.74,2.74,0,0,1-1.25,1.33l-19,10a8.25,8.25,0,0,1-1.29-4.13s8.11-4.85,8.7-8.29a.68.68,0,0,1,.48-.56c1.79-.52,8.73-2.66,11.71-5.75a.85.85,0,0,1,1.35.2A45.5,45.5,0,0,0,269.31,369.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.52,370.69h0c-.14,0-3.22-.36-4-1.4a1,1,0,0,1-.21-.73.73.73,0,0,1,.56-.66c1-.24,3.1,1.32,3.89,2.43a.23.23,0,0,1,0,.25A.21.21,0,0,1,252.52,370.69Zm-3.46-2.37a.32.32,0,0,0-.14,0c-.09,0-.19.07-.22.29a.51.51,0,0,0,.11.38c.48.62,2.14,1,3.17,1.16A5.7,5.7,0,0,0,249.06,368.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.14,373.05a.94.94,0,0,1-.67-.26.73.73,0,0,1-.21-.84c.39-.95,2.92-1.72,4.26-1.71a.21.21,0,0,1,.2.13.23.23,0,0,1,0,.24c-.09.1-2.19,2.4-3.51,2.44Zm2.82-2.33c-1.3.15-3,.8-3.28,1.4,0,.09-.06.2.1.35a.5.5,0,0,0,.38.13C249.94,372.58,251.22,371.46,252,370.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.59,239l5.91,11.41c8.72,16.84,2.41,39.31-13.9,49.53-9.52,6-22.78,13.26-30.58,17.19,5.07,12.33,8.71,28.1,10.31,40.07L248,364.88c-7.95-14-19.25-33.84-26.86-46.93a15.87,15.87,0,0,1,1.25-17C240.93,275.4,293.59,239,293.59,239Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.65,359.31a.45.45,0,0,1-.44-.37c-1.86-9.62-11-37.92-17.06-49.9a.44.44,0,0,1,0-.37.47.47,0,0,1,.26-.26c26.09-9.63,42-19.45,46.06-28.4,7.1-15.72-1.07-30.77-8.3-37.06a.45.45,0,0,1,0-.63.44.44,0,0,1,.63,0c7.43,6.46,15.83,21.94,8.53,38.1-4.18,9.25-19.69,18.91-46.1,28.7,6.1,12.29,15.07,40.14,16.92,49.69a.46.46,0,0,1-.36.53Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.66,196.48l-1.08.75-1,.62c-.63.41-1.27.79-1.9,1.17-1.27.75-2.56,1.45-3.87,2.12a76.7,76.7,0,0,1-8.12,3.56,57.12,57.12,0,0,1-18.31,3.7c-.84,0-1.66,0-2.51,0l-1.29-.07-1.44-.13a32.29,32.29,0,0,1-5-1.13,53.55,53.55,0,0,1-8.28-3.32l-1.92-1-1.85-1q-1.84-1-3.6-2.19a61.62,61.62,0,0,1-6.78-5.07,5.24,5.24,0,0,1,4.44-9.11l.32.07c4.93,1,9.94,2.22,14.64,3.07,2.35.42,4.66.75,6.77,1a22.9,22.9,0,0,0,2.69.11l1.2-.11c.45,0,.93-.12,1.39-.18a48.45,48.45,0,0,0,12-3.69c2.06-.86,4.1-1.88,6.14-2.93,1-.53,2-1.08,3-1.63l2.72-1.56.64-.37a10.3,10.3,0,0,1,11,17.41Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.77,187.35l-.78,5.9c-3,5.51-9.39.47-9.39.47l-4.07-1.17a3.15,3.15,0,0,1-2-3.54l.51-4.13a3.28,3.28,0,0,1,3.4-3.08l3.67.43a6.39,6.39,0,0,1,3,1.13Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.54,169.05c-2.29-3.52-10.85-1.52-15,4.23-1.94.1-8.87,7.71-14.51,9.75s-9.16,9.46-7.15,13.26c3.71,7,6.08,10.31,11.54,10.37s12.21-4.14,17.51-9S271.83,180.28,264.54,169.05Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.54,183.12c-4.8-2.46-8.76,2.85-8.2,8.93a29,29,0,0,0,5.1,14.58c2.51,3.33,6.39,2.7,10,2.17,3.11-.45,4.54-1.73,2.77-4.42s-7.67-6.26-9.27-14.16C232.13,186.26,234.75,184.26,232.54,183.12Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.59,234.32c-1,1-1.88,4.82-.14,10.73,1.2,4.08,6.64,2.29,6.64,2.29s.64,7.36,7.25,9.2c10.88,3,52.39,4,59.66-1.14C278.91,254.27,227.59,234.32,227.59,234.32Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.68,165.33a190.61,190.61,0,0,1,21.52,2.3,22.18,22.18,0,0,1,17.88,27.06c-6.51,27.65-4,55.9-4.77,61.41,0,0-64,6.55-73-12.77-12.17-21.88,10.5-34.93,19.44-64.5C251.09,171.06,259.58,165,267.68,165.33Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.68,165.33a190.61,190.61,0,0,1,21.52,2.3,22.18,22.18,0,0,1,17.88,27.06c-6.51,27.65-4,55.9-4.77,61.41,0,0-64,6.55-73-12.77-12.17-21.88,10.5-34.93,19.44-64.5C251.09,171.06,259.58,165,267.68,165.33Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.92,167.62l-.12-.05-.34-.14-.09.06c-5.33-.85-10.87-1.49-16.17-1.88q-1.95-.15-3.84-.24a8.12,8.12,0,0,0-3.79,4.06c-1.79,4-.81,8.5,2.64,12.14l.28.3.42,0c7.84-.43,22.68-6.09,23.49-10.87C291.54,170.16,291.4,168.63,288.92,167.62Z",
    style: {
      fill: "#fafafa",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.62,190.8l1,2.18c.32.69.6,1.38.88,2.07.58,1.37,1.08,2.76,1.59,4.15,1,2.78,1.86,5.6,2.59,8.49.38,1.43.72,2.89,1.05,4.35s.57,2.94.82,4.44a80.27,80.27,0,0,1,1,9.15l0,.62a9,9,0,0,1-.55,3.61,13.74,13.74,0,0,1-4.5,5.94,14.72,14.72,0,0,1-5.34,2.48,22.6,22.6,0,0,1-7.64.37,36.21,36.21,0,0,1-5.84-1.13c-1.8-.49-3.51-1-5.17-1.64a85.83,85.83,0,0,1-9.44-4.17,86.87,86.87,0,0,1-8.79-5.12,5.18,5.18,0,0,1,4-9.37l.23.05c3,.64,6.08,1.38,9.08,2s6,1.21,8.9,1.61c1.44.2,2.85.38,4.2.47a29.14,29.14,0,0,0,3.7,0c1.05,0,1.95-.31,1.9-.44s-.41,0-1,.4a5,5,0,0,0-1.7,2.11l-.51,4.23c-.49-2.35-1.06-4.7-1.72-7.08-.33-1.19-.69-2.38-1.07-3.57s-.73-2.39-1.14-3.58c-.83-2.38-1.65-4.77-2.55-7.14l-1.36-3.54-1.3-3.34-.21-.53a10.31,10.31,0,0,1,18.94-8.11Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.24,220.42l-1.66,3.37c-4.58,4.27-9-2.57-9-2.57l-3.48-2.42a3.16,3.16,0,0,1-.79-4l1.82-3.75a3.29,3.29,0,0,1,4.21-1.82l3.34,1.58a6.5,6.5,0,0,1,2.44,2l2.84,3.85A3.61,3.61,0,0,1,276.24,220.42Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.81,172.05c4.18.36,13,10.18,12.54,17.27,1.44,1.31,3.39,8.36,6.47,13.51s1.08,13.13-2.88,14.8c-7.31,3.07-11.24,4.12-15.5.7s-8.36-14.09-8.8-21.26C290,186.55,291.39,171.42,298.81,172.05Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.87,214.06c-2.81,4.61,2.19,8.95,8.3,8.84a29,29,0,0,0,14.92-4c3.51-2.26,3.16-6.18,2.9-9.81-.22-3.14-1.39-4.65-4.21-3.09s-6.8,7.19-14.8,8.2C298,214.7,296.17,211.94,294.87,214.06Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.45,169.15a8.27,8.27,0,0,1,4.33-3.33,7.72,7.72,0,0,0,.66-5.13l19.89-4.16c-2.21,6.21-3.95,11.12-1.9,14.45-4,1.92-11.38,5.36-18.92,4.37S265,171.69,266.45,169.15Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.53,161.3l14.54.64c-5,4.36-12.05,5.48-15,3.19A7.8,7.8,0,0,0,271.53,161.3Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.08,147.1c-3.16,8.73-5.5,14.59-11.76,16.82-12.45,4.44-17.17-2.22-16.67-11.74.44-8.57,5.54-21.4,15.28-22.29A12.79,12.79,0,0,1,296.08,147.1Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294,154.73c-6.18-2.72-7-7.32-3.69-8.87-2-2.6-3.2-6.48.14-8.24-1.3,1-7.53-2.61-6.82-5.38-6.27,3-12.94,2.19-10.55-3.8s12.75-8.29,14.52-5.34c9.79-4,15.79,3.61,12.49,6.27,6.91.54,9.26,8.74,4.62,12.17C310.69,146.07,304.34,153.84,294,154.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.15,152.6a6.84,6.84,0,0,1,1.21.36.21.21,0,0,1,.11.28.24.24,0,0,1-.3.13,6.43,6.43,0,0,0-5.53.37.22.22,0,0,1-.31-.05.22.22,0,0,1,.08-.3A6.65,6.65,0,0,1,278.15,152.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.91,145.38a4.28,4.28,0,0,1,3.17.77A8.32,8.32,0,0,1,283.91,145.38Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.77,146.15a3.5,3.5,0,0,1,2.61,1.4A7,7,0,0,1,283.77,146.15Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.63,141.9s-.57-1-1.22-.65A1.78,1.78,0,0,0,271.63,141.9Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.35,142.58s-.45-.91-1-.23A.84.84,0,0,0,271.35,142.58Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.84,134.46a26.26,26.26,0,0,1,8,1.68A73.67,73.67,0,0,1,276.84,134.46Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.52,135.65s6.19.95,9,2.94A51.12,51.12,0,0,1,275.52,135.65Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.2,155.32a8.73,8.73,0,0,1-5.79,3.42c-3.06.41-4.19-2.44-3-5.12,1.07-2.4,4-5.51,6.88-4.68S299.88,153,298.2,155.32Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.41,145.16c-.21.73-.77,1.2-1.24,1.05s-.68-.85-.47-1.57.77-1.19,1.24-1S281.63,144.44,281.41,145.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.71,143c-.21.72-.77,1.19-1.24,1.05s-.69-.85-.47-1.57.77-1.19,1.24-1S273.92,142.28,273.71,143Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276,144.31l-1.74,6.1s-2.48-.14-3.55-1.58A13.21,13.21,0,0,1,276,144.31Z",
    style: {
      fill: "#ed893e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.49,139.82a.51.51,0,0,0-.22,0,.44.44,0,0,0-.39.49,4.41,4.41,0,0,0,2.11,3.47.45.45,0,0,0,.41-.79h0a3.54,3.54,0,0,1-1.64-2.76A.44.44,0,0,0,282.49,139.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.89,137.62a.48.48,0,0,0-.41.1,3.46,3.46,0,0,1-3.06.89.44.44,0,0,0-.54.32.45.45,0,0,0,.31.54,4.36,4.36,0,0,0,3.89-1.08.45.45,0,0,0,0-.63A.52.52,0,0,0,273.89,137.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.86,181c10.43-.59,28.71-9.23,20.72-12.5-5.27,3.84-13.91,5.11-17.95,4.94-1.44-1.5-1.75-5.54.15-7.57C266.57,165.28,260.91,173.6,267.86,181Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.63,173.39c2.93-1.84,12-5.68,17.67-7.35a1.89,1.89,0,0,1,1.72,3.29h0S285.42,174,270.63,173.39Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271,173.72h0a.87.87,0,0,0,.93-.33l.81-1.22a.44.44,0,0,0-.26-.69h0a.88.88,0,0,0-.93.33l-.8,1.22A.43.43,0,0,0,271,173.72Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.27,173.57h0a.88.88,0,0,0,.85-.5l.54-1.32a.44.44,0,0,0-.41-.62h0a.88.88,0,0,0-.85.5l-.54,1.32A.44.44,0,0,0,270.27,173.57Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.63,173.39s.31-4.17.23-7.14a1.21,1.21,0,0,0-2.3-.47,3.23,3.23,0,0,0-.21.61S268.92,172.08,270.63,173.39Z",
    style: {
      fill: "#FF0000"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--bunch-of-envelopes--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M280.41,228.13a175.69,175.69,0,0,0-18.32,9.54,187.41,187.41,0,0,1,30.75,6.65A171.45,171.45,0,0,0,280.41,228.13Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.69,237a189,189,0,0,1,28,6.06,2.7,2.7,0,0,1,2,3.29q-2.4,7.22-4.81,14.42a2.69,2.69,0,0,1-3.32,1.65,167.52,167.52,0,0,0-24.8-5.37,2.6,2.6,0,0,1-2.28-2.86l1.95-15A2.77,2.77,0,0,1,263.69,237Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.69,237a189,189,0,0,1,28,6.06,2.7,2.7,0,0,1,2,3.29q-2.4,7.22-4.81,14.42a2.69,2.69,0,0,1-3.32,1.65,167.52,167.52,0,0,0-24.8-5.37,2.6,2.6,0,0,1-2.28-2.86l1.95-15A2.77,2.77,0,0,1,263.69,237Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.76,257.07a167.52,167.52,0,0,1,24.8,5.37,2.73,2.73,0,0,0,1.85-.1,151.73,151.73,0,0,0-11.4-15,157.61,157.61,0,0,0-16.88,8.91A2.64,2.64,0,0,0,260.76,257.07Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.76,257.07a167.52,167.52,0,0,1,24.8,5.37,2.73,2.73,0,0,0,1.85-.1,151.73,151.73,0,0,0-11.4-15,157.61,157.61,0,0,0-16.88,8.91A2.64,2.64,0,0,0,260.76,257.07Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.19,250.91a163.63,163.63,0,0,1,17.8-7.06,3.16,3.16,0,0,0-1.32-.77,189,189,0,0,0-28-6.06,3.37,3.37,0,0,0-1.53.15A159.43,159.43,0,0,1,275.19,250.91Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.19,250.91a163.63,163.63,0,0,1,17.8-7.06,3.16,3.16,0,0,0-1.32-.77,189,189,0,0,0-28-6.06,3.37,3.37,0,0,0-1.53.15A159.43,159.43,0,0,1,275.19,250.91Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.9,297.66l-26.77-16.12a3.32,3.32,0,0,0-4.47,1l-10.19,16a3.12,3.12,0,0,0,1,4.35L341.28,319a3.33,3.33,0,0,0,4.48-1L356,302A3.12,3.12,0,0,0,354.9,297.66Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.9,297.66l-26.77-16.12a3.32,3.32,0,0,0-4.47,1l-10.19,16a3.12,3.12,0,0,0,1,4.35L341.28,319a3.33,3.33,0,0,0,4.48-1L356,302A3.12,3.12,0,0,0,354.9,297.66Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.28,319l-26.76-16.12a3.12,3.12,0,0,1-1.39-1.76l23-3.11,7.38,21.41A3.28,3.28,0,0,1,341.28,319Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.28,319l-26.76-16.12a3.12,3.12,0,0,1-1.39-1.76l23-3.11,7.38,21.41A3.28,3.28,0,0,1,341.28,319Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.67,301.89l-7.17-20.82a3.4,3.4,0,0,1,1.64.47l26.76,16.12a3.2,3.2,0,0,1,1.16,1.21Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.62,252.69l-22.53-13.56a2.8,2.8,0,0,0-3.77.85l-8.57,13.44a2.61,2.61,0,0,0,.88,3.66l22.53,13.57a2.8,2.8,0,0,0,3.77-.86l8.57-13.44A2.62,2.62,0,0,0,324.62,252.69Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.62,252.69l-22.53-13.56a2.8,2.8,0,0,0-3.77.85l-8.57,13.44a2.61,2.61,0,0,0,.88,3.66l22.53,13.57a2.8,2.8,0,0,0,3.77-.86l8.57-13.44A2.62,2.62,0,0,0,324.62,252.69Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.16,270.65l-22.53-13.57a2.66,2.66,0,0,1-1.17-1.48L308.84,253l6.21,18A2.81,2.81,0,0,1,313.16,270.65Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.16,270.65l-22.53-13.57a2.66,2.66,0,0,1-1.17-1.48L308.84,253l6.21,18A2.81,2.81,0,0,1,313.16,270.65Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.75,256.25l-6-17.52a2.84,2.84,0,0,1,1.37.39l22.53,13.57a2.66,2.66,0,0,1,1,1Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195,283.26l-26.49-3.93a2.77,2.77,0,0,0-3.15,2.25l-2.49,15.81a2.7,2.7,0,0,0,2.32,3.06l26.49,3.93a2.76,2.76,0,0,0,3.15-2.25l2.49-15.8A2.72,2.72,0,0,0,195,283.26Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195,283.26l-26.49-3.93a2.77,2.77,0,0,0-3.15,2.25l-2.49,15.81a2.7,2.7,0,0,0,2.32,3.06l26.49,3.93a2.76,2.76,0,0,0,3.15-2.25l2.49-15.8A2.72,2.72,0,0,0,195,283.26Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.68,304.39l-26.49-3.94a2.74,2.74,0,0,1-1.7-.93l17-9.9L193.58,304A2.81,2.81,0,0,1,191.68,304.39Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.68,304.39l-26.49-3.94a2.74,2.74,0,0,1-1.7-.93l17-9.9L193.58,304A2.81,2.81,0,0,1,191.68,304.39Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.84,293.46l-12.77-14a2.78,2.78,0,0,1,1.44-.16L195,283.26a2.77,2.77,0,0,1,1.33.58Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.35,275.14c-8.79,1.89-18,2.36-26.75,4.26a2.63,2.63,0,0,0-2,3.25q2.12,7.78,4.21,15.57a2.89,2.89,0,0,0,3.42,2c8.78-1.89,18-2.36,26.74-4.25a2.64,2.64,0,0,0,2-3.26q-2.1-7.79-4.21-15.57A2.89,2.89,0,0,0,321.35,275.14Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.35,275.14c-8.79,1.89-18,2.36-26.75,4.26a2.63,2.63,0,0,0-2,3.25q2.12,7.78,4.21,15.57a2.89,2.89,0,0,0,3.42,2c8.78-1.89,18-2.36,26.74-4.25a2.64,2.64,0,0,0,2-3.26q-2.1-7.79-4.21-15.57A2.89,2.89,0,0,0,321.35,275.14Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327,296c-8.78,1.89-18,2.36-26.74,4.26a3,3,0,0,1-2-.25c3.88-5.18,7.9-9.84,11.93-14.49,6.17,3.31,12.35,6.63,18.38,9.42A2.62,2.62,0,0,1,327,296Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327,296c-8.78,1.89-18,2.36-26.74,4.26a3,3,0,0,1-2-.25c3.88-5.18,7.9-9.84,11.93-14.49,6.17,3.31,12.35,6.63,18.38,9.42A2.62,2.62,0,0,1,327,296Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.21,289.25c-6-3.22-12-6.44-17.89-9.18a2.61,2.61,0,0,1,1.28-.68c8.78-1.89,18-2.36,26.74-4.25a3,3,0,0,1,1.48.05C319,280.2,315.12,284.73,311.21,289.25Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.55,256.08a216.44,216.44,0,0,1,21.32,14.05,232.91,232.91,0,0,0-38.79,4.35A210.28,210.28,0,0,1,277.55,256.08Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297,269.14a233.69,233.69,0,0,0-35.3,3.95,3.37,3.37,0,0,0-2.93,3.8l4,18.38a3.31,3.31,0,0,0,3.86,2.46,206.79,206.79,0,0,1,31.3-3.5,3.27,3.27,0,0,0,3.19-3.25q-.21-9.39-.4-18.78A3.42,3.42,0,0,0,297,269.14Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297,269.14a233.69,233.69,0,0,0-35.3,3.95,3.37,3.37,0,0,0-2.93,3.8l4,18.38a3.31,3.31,0,0,0,3.86,2.46,206.79,206.79,0,0,1,31.3-3.5,3.27,3.27,0,0,0,3.19-3.25q-.21-9.39-.4-18.78A3.42,3.42,0,0,0,297,269.14Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.92,294.23a206.8,206.8,0,0,0-31.29,3.5,3.37,3.37,0,0,1-2.26-.36,192.68,192.68,0,0,1,16.05-17.1,196.48,196.48,0,0,1,19.63,13.11A3.37,3.37,0,0,1,297.92,294.23Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.92,294.23a206.8,206.8,0,0,0-31.29,3.5,3.37,3.37,0,0,1-2.26-.36,192.68,192.68,0,0,1,16.05-17.1,196.48,196.48,0,0,1,19.63,13.11A3.37,3.37,0,0,1,297.92,294.23Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281,284.81a205.81,205.81,0,0,0-21-10.94,4,4,0,0,1,1.73-.78,233.55,233.55,0,0,1,35.3-3.95,4.1,4.1,0,0,1,1.87.38A198.86,198.86,0,0,0,281,284.81Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281,284.81a205.81,205.81,0,0,0-21-10.94,4,4,0,0,1,1.73-.78,233.55,233.55,0,0,1,35.3-3.95,4.1,4.1,0,0,1,1.87.38A198.86,198.86,0,0,0,281,284.81Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.08,275.92,257,280.6a3.19,3.19,0,0,0-2.72,3.61l3,18.56a3.26,3.26,0,0,0,3.72,2.64L292,300.72a3.18,3.18,0,0,0,2.72-3.6l-3-18.57A3.24,3.24,0,0,0,288.08,275.92Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.08,275.92,257,280.6a3.19,3.19,0,0,0-2.72,3.61l3,18.56a3.26,3.26,0,0,0,3.72,2.64L292,300.72a3.18,3.18,0,0,0,2.72-3.6l-3-18.57A3.24,3.24,0,0,0,288.08,275.92Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292,300.72l-31.11,4.69a3.31,3.31,0,0,1-2.24-.46L274.09,288,294,299.63A3.2,3.2,0,0,1,292,300.72Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292,300.72l-31.11,4.69a3.31,3.31,0,0,1-2.24-.46L274.09,288,294,299.63A3.2,3.2,0,0,1,292,300.72Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.81,292.55l-19.4-11.27a3.21,3.21,0,0,1,1.56-.68l31.11-4.68a3.35,3.35,0,0,1,1.7.18Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "260.07 249.97 270.77 266.65 242.06 258.92 260.07 249.97",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.66,265.41l-26-7a2.81,2.81,0,0,0-3.43,1.89l-4.43,15.51a2.72,2.72,0,0,0,1.95,3.33l26,7a2.8,2.8,0,0,0,3.43-1.88l4.42-15.51A2.7,2.7,0,0,0,269.66,265.41Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.66,265.41l-26-7a2.81,2.81,0,0,0-3.43,1.89l-4.43,15.51a2.72,2.72,0,0,0,1.95,3.33l26,7a2.8,2.8,0,0,0,3.43-1.88l4.42-15.51A2.7,2.7,0,0,0,269.66,265.41Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.75,286.13l-26-7a2.69,2.69,0,0,1-1.57-1.13l18.16-7.93L265.7,286A2.77,2.77,0,0,1,263.75,286.13Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.75,286.13l-26-7a2.69,2.69,0,0,1-1.57-1.13l18.16-7.93L265.7,286A2.77,2.77,0,0,1,263.75,286.13Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.26,273.85l-11-15.44a2.89,2.89,0,0,1,1.46,0l26,7a2.7,2.7,0,0,1,1.26.73Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.26,273.85l-11-15.44a2.89,2.89,0,0,1,1.46,0l26,7a2.7,2.7,0,0,1,1.26.73Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.51,281.48c-10.37-1.62-20.53-4.94-30.9-6.56a3.15,3.15,0,0,0-3.61,2.7l-2.34,18.65a3.29,3.29,0,0,0,2.83,3.57c10.37,1.62,20.53,4.94,30.9,6.56a3.14,3.14,0,0,0,3.61-2.69l2.34-18.65A3.3,3.3,0,0,0,261.51,281.48Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.51,281.48c-10.37-1.62-20.53-4.94-30.9-6.56a3.15,3.15,0,0,0-3.61,2.7l-2.34,18.65a3.29,3.29,0,0,0,2.83,3.57c10.37,1.62,20.53,4.94,30.9,6.56a3.14,3.14,0,0,0,3.61-2.69l2.34-18.65A3.3,3.3,0,0,0,261.51,281.48Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.39,306.4c-10.37-1.62-20.53-4.94-30.9-6.55a3.47,3.47,0,0,1-2-1.09c6.51-4,12.94-7.36,19.36-10.74,5.23,6.18,10.47,12.36,15.78,17.91A3.14,3.14,0,0,1,258.39,306.4Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.39,306.4c-10.37-1.62-20.53-4.94-30.9-6.55a3.47,3.47,0,0,1-2-1.09c6.51-4,12.94-7.36,19.36-10.74,5.23,6.18,10.47,12.36,15.78,17.91A3.14,3.14,0,0,1,258.39,306.4Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.26,292.56c-5.08-6-10.17-12-15.33-17.44a3.16,3.16,0,0,1,1.68-.2c10.37,1.62,20.53,4.94,30.9,6.56a3.33,3.33,0,0,1,1.57.68C256.76,286,250.51,289.28,244.26,292.56Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.86,269.26a194.19,194.19,0,0,1,20.27,10.88,207.85,207.85,0,0,0-34.34,7A190,190,0,0,1,204.86,269.26Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.36,279.4a208.81,208.81,0,0,0-31.25,6.36,3,3,0,0,0-2.3,3.64q2.58,8.06,5.15,16.12a3,3,0,0,0,3.67,1.89,185.05,185.05,0,0,1,27.7-5.64,2.91,2.91,0,0,0,2.58-3.16L227,281.83A3.07,3.07,0,0,0,223.36,279.4Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.36,279.4a208.81,208.81,0,0,0-31.25,6.36,3,3,0,0,0-2.3,3.64q2.58,8.06,5.15,16.12a3,3,0,0,0,3.67,1.89,185.05,185.05,0,0,1,27.7-5.64,2.91,2.91,0,0,0,2.58-3.16L227,281.83A3.07,3.07,0,0,0,223.36,279.4Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.33,301.77a186.32,186.32,0,0,0-27.7,5.64,3.05,3.05,0,0,1-2-.14,169.91,169.91,0,0,1,12.9-16.58,174.22,174.22,0,0,1,18.68,10.15A3,3,0,0,1,226.33,301.77Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.33,301.77a186.32,186.32,0,0,0-27.7,5.64,3.05,3.05,0,0,1-2-.14,169.91,169.91,0,0,1,12.9-16.58,174.22,174.22,0,0,1,18.68,10.15A3,3,0,0,1,226.33,301.77Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.35,294.7a184.89,184.89,0,0,0-19.72-8.1,3.38,3.38,0,0,1,1.48-.84,208.81,208.81,0,0,1,31.25-6.36,3.49,3.49,0,0,1,1.71.19A177,177,0,0,0,210.35,294.7Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.35,294.7a184.89,184.89,0,0,0-19.72-8.1,3.38,3.38,0,0,1,1.48-.84,208.81,208.81,0,0,1,31.25-6.36,3.49,3.49,0,0,1,1.71.19A177,177,0,0,0,210.35,294.7Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.38,302.58l36.09,2.17A3.69,3.69,0,0,1,179,308.6l-1.38,21.52a3.7,3.7,0,0,1-4,3.4l-36.09-2.18a3.66,3.66,0,0,1-3.49-3.84L135.42,306A3.7,3.7,0,0,1,139.38,302.58Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.38,302.58l36.09,2.17A3.69,3.69,0,0,1,179,308.6l-1.38,21.52a3.7,3.7,0,0,1-4,3.4l-36.09-2.18a3.66,3.66,0,0,1-3.49-3.84L135.42,306A3.7,3.7,0,0,1,139.38,302.58Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.55,331.34l36.08,2.18a3.71,3.71,0,0,0,2.5-.76L156.7,315l-21.55,15.29A3.66,3.66,0,0,0,137.55,331.34Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.55,331.34l36.08,2.18a3.71,3.71,0,0,0,2.5-.76L156.7,315l-21.55,15.29A3.66,3.66,0,0,0,137.55,331.34Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.36,320.24l21-14.87a3.71,3.71,0,0,0-1.85-.62l-36.09-2.18a3.9,3.9,0,0,0-1.92.39Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.43,255.09l24,10a2.61,2.61,0,0,1,1.41,3.44l-6.33,14.31a2.73,2.73,0,0,1-3.54,1.37l-24-10a2.6,2.6,0,0,1-1.42-3.44l6.33-14.3A2.74,2.74,0,0,1,121.43,255.09Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.43,255.09l24,10a2.61,2.61,0,0,1,1.41,3.44l-6.33,14.31a2.73,2.73,0,0,1-3.54,1.37l-24-10a2.6,2.6,0,0,1-1.42-3.44l6.33-14.3A2.74,2.74,0,0,1,121.43,255.09Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113,274.2l24,10a2.77,2.77,0,0,0,1.9.08l-8.76-16.67-18.48,5.3A2.61,2.61,0,0,0,113,274.2Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113,274.2l24,10a2.77,2.77,0,0,0,1.9.08l-8.76-16.67-18.48,5.3A2.61,2.61,0,0,0,113,274.2Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.55,271.1l18-5.15a2.56,2.56,0,0,0-1.1-.86l-24-10a2.73,2.73,0,0,0-1.4-.19Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.59,245.37l-27.6,6a1.7,1.7,0,0,0-1.09,2.76l7.22,11.35a4,4,0,0,0,3.92,1.68l27.6-6a1.69,1.69,0,0,0,1.09-2.76l-7.22-11.35A4,4,0,0,0,233.59,245.37Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.59,245.37l-27.6,6a1.7,1.7,0,0,0-1.09,2.76l7.22,11.35a4,4,0,0,0,3.92,1.68l27.6-6a1.69,1.69,0,0,0,1.09-2.76l-7.22-11.35A4,4,0,0,0,233.59,245.37Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.35,261.23l-27,5.84a4.35,4.35,0,0,1-2.15-.09l9.57-12.4,21.12,5.75A2.47,2.47,0,0,1,243.35,261.23Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.35,261.23l-27,5.84a4.35,4.35,0,0,1-2.15-.09l9.57-12.4,21.12,5.75A2.47,2.47,0,0,1,243.35,261.23Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.58,257.46l-20.53-5.6a2.77,2.77,0,0,1,1.23-.58l27-5.85a4.47,4.47,0,0,1,1.59,0Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.15,312.91l30.42-4.52a3.18,3.18,0,0,1,3.62,2.59l2.86,18.14a3.12,3.12,0,0,1-2.67,3.52L330,337.16a3.17,3.17,0,0,1-3.62-2.59l-2.86-18.14A3.11,3.11,0,0,1,326.15,312.91Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.15,312.91l30.42-4.52a3.18,3.18,0,0,1,3.62,2.59l2.86,18.14a3.12,3.12,0,0,1-2.67,3.52L330,337.16a3.17,3.17,0,0,1-3.62-2.59l-2.86-18.14A3.11,3.11,0,0,1,326.15,312.91Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330,337.16l30.41-4.52a3.17,3.17,0,0,0,1.95-1.06l-19.47-11.37-15.08,16.5A3.23,3.23,0,0,0,330,337.16Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330,337.16l30.41-4.52a3.17,3.17,0,0,0,1.95-1.06l-19.47-11.37-15.08,16.5A3.23,3.23,0,0,0,330,337.16Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.56,324.62l14.66-16a3.27,3.27,0,0,0-1.65-.19l-30.42,4.52a3.18,3.18,0,0,0-1.52.66Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.55 265.63 155.35 285.14 195.11 281.59 173.55 265.63",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.12,283.77l36-3.22a3.72,3.72,0,0,1,4.06,3.28l2,21.48a3.66,3.66,0,0,1-3.37,3.94l-36,3.22a3.71,3.71,0,0,1-4.06-3.28l-2-21.47A3.67,3.67,0,0,1,157.12,283.77Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.12,283.77l36-3.22a3.72,3.72,0,0,1,4.06,3.28l2,21.48a3.66,3.66,0,0,1-3.37,3.94l-36,3.22a3.71,3.71,0,0,1-4.06-3.28l-2-21.47A3.67,3.67,0,0,1,157.12,283.77Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.84,312.47l36-3.22a3.63,3.63,0,0,0,2.35-1.12l-22-14.66-18.88,18.32A3.68,3.68,0,0,0,159.84,312.47Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.84,312.47l36-3.22a3.63,3.63,0,0,0,2.35-1.12l-22-14.66-18.88,18.32A3.68,3.68,0,0,0,159.84,312.47Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.68,298.7,195,280.88a3.76,3.76,0,0,0-1.92-.33l-36,3.22a3.72,3.72,0,0,0-1.84.67Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.68,298.7,195,280.88a3.76,3.76,0,0,0-1.92-.33l-36,3.22a3.72,3.72,0,0,0-1.84.67Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.1,303.58c10.09,2.17,20.62,2.72,30.71,4.89a3,3,0,0,1,2.3,3.73l-4.83,17.88a3.32,3.32,0,0,1-3.92,2.28c-10.09-2.17-20.63-2.71-30.72-4.89a3,3,0,0,1-2.3-3.73l4.83-17.88A3.32,3.32,0,0,1,181.1,303.58Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.1,303.58c10.09,2.17,20.62,2.72,30.71,4.89a3,3,0,0,1,2.3,3.73l-4.83,17.88a3.32,3.32,0,0,1-3.92,2.28c-10.09-2.17-20.63-2.71-30.72-4.89a3,3,0,0,1-2.3-3.73l4.83-17.88A3.32,3.32,0,0,1,181.1,303.58Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.64,327.47c10.09,2.18,20.62,2.72,30.71,4.89a3.39,3.39,0,0,0,2.25-.28c-4.45-5.95-9.07-11.29-13.69-16.64-7.09,3.81-14.19,7.61-21.11,10.82A3,3,0,0,0,174.64,327.47Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.64,327.47c10.09,2.18,20.62,2.72,30.71,4.89a3.39,3.39,0,0,0,2.25-.28c-4.45-5.95-9.07-11.29-13.69-16.64-7.09,3.81-14.19,7.61-21.11,10.82A3,3,0,0,0,174.64,327.47Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.73,319.79c6.9-3.7,13.79-7.4,20.54-10.55a3,3,0,0,0-1.46-.77c-10.09-2.18-20.62-2.72-30.71-4.89a3.37,3.37,0,0,0-1.7.06C183.75,309.39,188.24,314.59,192.73,319.79Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.7,332.45a237.11,237.11,0,0,0-9,27.4A261.37,261.37,0,0,1,145.92,337,256.3,256.3,0,0,0,116.7,332.45Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.72,357.65a263,263,0,0,1,34.74-20.79,4,4,0,0,1,5.42,1.41l9.81,19.35A3.64,3.64,0,0,1,157,362.5a232.74,232.74,0,0,0-30.79,18.43,3.88,3.88,0,0,1-5.25-.73L107.58,363A3.77,3.77,0,0,1,108.72,357.65Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.72,357.65a263,263,0,0,1,34.74-20.79,4,4,0,0,1,5.42,1.41l9.81,19.35A3.64,3.64,0,0,1,157,362.5a232.74,232.74,0,0,0-30.79,18.43,3.88,3.88,0,0,1-5.25-.73L107.58,363A3.77,3.77,0,0,1,108.72,357.65Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.21,380.93A233.82,233.82,0,0,1,157,362.5a3.68,3.68,0,0,0,1.78-1.89,231.11,231.11,0,0,0-27-4.35,213.47,213.47,0,0,0-8.13,25.36A3.78,3.78,0,0,0,126.21,380.93Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.21,380.93A233.82,233.82,0,0,1,157,362.5a3.68,3.68,0,0,0,1.78-1.89,231.11,231.11,0,0,0-27-4.35,213.47,213.47,0,0,0-8.13,25.36A3.78,3.78,0,0,0,126.21,380.93Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.63,360.73a222,222,0,0,1,11-24.36,4.61,4.61,0,0,0-2.14.49,264.6,264.6,0,0,0-34.73,20.78,4.47,4.47,0,0,0-1.41,1.64A237.24,237.24,0,0,1,134.63,360.73Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.63,360.73a222,222,0,0,1,11-24.36,4.61,4.61,0,0,0-2.14.49,264.6,264.6,0,0,0-34.73,20.78,4.47,4.47,0,0,0-1.41,1.64A237.24,237.24,0,0,1,134.63,360.73Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.28,304.47,255,309.86a3.65,3.65,0,0,1,3.12,4.14l-3.4,21.31a3.75,3.75,0,0,1-4.27,3L214.74,333a3.66,3.66,0,0,1-3.12-4.14L215,307.5A3.74,3.74,0,0,1,219.28,304.47Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.28,304.47,255,309.86a3.65,3.65,0,0,1,3.12,4.14l-3.4,21.31a3.75,3.75,0,0,1-4.27,3L214.74,333a3.66,3.66,0,0,1-3.12-4.14L215,307.5A3.74,3.74,0,0,1,219.28,304.47Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.74,333l35.72,5.38a3.78,3.78,0,0,0,2.57-.53l-17.68-19.42-22.9,13.31A3.71,3.71,0,0,0,214.74,333Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.74,333l35.72,5.38a3.78,3.78,0,0,0,2.57-.53l-17.68-19.42-22.9,13.31A3.71,3.71,0,0,0,214.74,333Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.53,323.57l22.27-12.94a3.82,3.82,0,0,0-1.79-.78l-35.72-5.38a3.86,3.86,0,0,0-1.95.22Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "235.34 324.11 208.9 322.61 210.92 289.05 237.36 290.56 235.34 324.11",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "234.74 297.69 212.67 296.44 212.77 294.77 234.84 296.02 234.74 297.69",
    style: {
      fill: "#FF0000",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "225.63 302.37 212.36 301.62 212.46 299.95 225.73 300.7 225.63 302.37",
    style: {
      fill: "#FF0000",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "232.4 302.75 228.06 302.51 228.16 300.84 232.5 301.08 232.4 302.75",
    style: {
      fill: "#FF0000",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "234.11 308.05 212.05 306.79 212.15 305.12 234.21 306.37 234.11 308.05",
    style: {
      fill: "#FF0000",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.92 312.94 211.74 311.97 211.84 310.3 229.02 311.27 228.92 312.94",
    style: {
      fill: "#FF0000",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "233.49 318.39 220.52 317.66 220.62 315.99 233.59 316.72 233.49 318.39",
    style: {
      fill: "#FF0000",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "211.43 317.14 218.37 317.54 218.47 315.87 211.53 315.47 211.43 317.14",
    style: {
      fill: "#FF0000",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.15 298.52 160.65 303.95 146.84 281.52 166.34 276.09 180.15 298.52",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "167.71 281.4 151.44 285.93 150.76 284.81 167.03 280.28 167.71 281.4",
    style: {
      fill: "#FF0000",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.36 286.66 153.57 289.39 152.89 288.27 162.67 285.55 163.36 286.66",
    style: {
      fill: "#FF0000",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "168.35 285.27 165.15 286.16 164.46 285.05 167.66 284.15 168.35 285.27",
    style: {
      fill: "#FF0000",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "171.97 288.32 155.7 292.85 155.01 291.73 171.28 287.2 171.97 288.32",
    style: {
      fill: "#FF0000",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.5 292.78 157.83 296.31 157.15 295.19 169.81 291.66 170.5 292.78",
    style: {
      fill: "#FF0000",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "176.23 295.23 166.67 297.9 165.98 296.78 175.54 294.12 176.23 295.23",
    style: {
      fill: "#FF0000",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "159.96 299.76 165.08 298.34 164.39 297.22 159.27 298.65 159.96 299.76",
    style: {
      fill: "#FF0000",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "251.44 274.69 239.16 293.83 272.12 284.96 251.44 274.69",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.43,292.41l29.85-8a3.23,3.23,0,0,1,3.94,2.16l5.07,17.81a3.11,3.11,0,0,1-2.22,3.82l-29.85,8a3.21,3.21,0,0,1-3.93-2.16l-5.08-17.8A3.11,3.11,0,0,1,240.43,292.41Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.43,292.41l29.85-8a3.23,3.23,0,0,1,3.94,2.16l5.07,17.81a3.11,3.11,0,0,1-2.22,3.82l-29.85,8a3.21,3.21,0,0,1-3.93-2.16l-5.08-17.8A3.11,3.11,0,0,1,240.43,292.41Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.22,316.21l29.85-8a3.18,3.18,0,0,0,1.81-1.29L258,297.77,245,316A3.23,3.23,0,0,0,247.22,316.21Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.22,316.21l29.85-8a3.18,3.18,0,0,0,1.81-1.29L258,297.77,245,316A3.23,3.23,0,0,0,247.22,316.21Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.27,302.1,272,284.37a3.16,3.16,0,0,0-1.67,0l-29.85,8a3.16,3.16,0,0,0-1.44.84Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.27,302.1,272,284.37a3.16,3.16,0,0,0-1.67,0l-29.85,8a3.16,3.16,0,0,0-1.44.84Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.79,310.87c11.91-1.86,23.57-5.68,35.48-7.53a3.61,3.61,0,0,1,4.15,3.09q1.33,10.69,2.68,21.41a3.78,3.78,0,0,1-3.25,4.11c-11.91,1.85-23.57,5.67-35.48,7.53a3.62,3.62,0,0,1-4.14-3.1q-1.35-10.69-2.68-21.41A3.76,3.76,0,0,1,249.79,310.87Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.79,310.87c11.91-1.86,23.57-5.68,35.48-7.53a3.61,3.61,0,0,1,4.15,3.09q1.33,10.69,2.68,21.41a3.78,3.78,0,0,1-3.25,4.11c-11.91,1.85-23.57,5.67-35.48,7.53a3.62,3.62,0,0,1-4.14-3.1q-1.35-10.69-2.68-21.41A3.76,3.76,0,0,1,249.79,310.87Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.38,339.48c11.9-1.86,23.56-5.67,35.47-7.53a3.93,3.93,0,0,0,2.32-1.25c-7.47-4.59-14.85-8.45-22.23-12.32-6,7.09-12,14.18-18.11,20.55A3.6,3.6,0,0,0,253.38,339.48Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.38,339.48c11.9-1.86,23.56-5.67,35.47-7.53a3.93,3.93,0,0,0,2.32-1.25c-7.47-4.59-14.85-8.45-22.23-12.32-6,7.09-12,14.18-18.11,20.55A3.6,3.6,0,0,0,253.38,339.48Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.59,323.58c5.84-6.89,11.69-13.78,17.61-20a3.68,3.68,0,0,0-1.93-.23c-11.91,1.86-23.57,5.67-35.47,7.53a3.9,3.9,0,0,0-1.81.78C255.24,316.06,262.42,319.82,269.59,323.58Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.17,298.39l25.15,9.15c8.13-9.18,4.18-22.75,12.3-31.92l-25.15-9.15C288.35,275.65,292.3,289.22,284.17,298.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.08,292.66l21,7.63c-.2.53-.42,1.06-.66,1.58l-21-7.63C289.66,293.72,289.88,293.19,290.08,292.66Z",
    style: {
      fill: "#FF0000",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.9,290.62l12.63,4.59c-.12.56-.26,1.12-.4,1.67l-12.62-4.59C299.65,291.74,299.78,291.18,299.9,290.62Z",
    style: {
      fill: "#FF0000",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.46,288.28l4.14,1.5c-.13.56-.26,1.12-.4,1.67l-4.13-1.5C293.21,289.4,293.34,288.84,293.46,288.28Z",
    style: {
      fill: "#FF0000",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.56,282.34l21,7.63c-.11.57-.21,1.13-.31,1.7l-21-7.63C292.35,283.47,292.45,282.91,292.56,282.34Z",
    style: {
      fill: "#FF0000",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.31,278.82l16.34,5.94c-.14.55-.27,1.11-.4,1.67l-16.34-5.94C298,279.93,298.17,279.37,298.31,278.82Z",
    style: {
      fill: "#FF0000",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.38,272.14l12.34,4.49c-.24.51-.45,1-.66,1.57l-12.33-4.48C294.93,273.19,295.15,272.66,295.38,272.14Z",
    style: {
      fill: "#FF0000",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.37,279.77l-6.6-2.4c-.24.52-.45,1-.66,1.58l6.61,2.4C315.92,280.82,316.14,280.29,316.37,279.77Z",
    style: {
      fill: "#FF0000",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.86,291.88A252.78,252.78,0,0,0,287,305.77a266.22,266.22,0,0,1,43.89,8.93A243.72,243.72,0,0,0,312.86,291.88Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.23,304.83A268.12,268.12,0,0,1,329.16,313a3.85,3.85,0,0,1,2.94,4.65q-3.3,10.31-6.58,20.6a3.84,3.84,0,0,1-4.69,2.42,236.58,236.58,0,0,0-35.4-7.21,3.72,3.72,0,0,1-3.29-4l2.49-21.43A3.94,3.94,0,0,1,289.23,304.83Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.23,304.83A268.12,268.12,0,0,1,329.16,313a3.85,3.85,0,0,1,2.94,4.65q-3.3,10.31-6.58,20.6a3.84,3.84,0,0,1-4.69,2.42,236.58,236.58,0,0,0-35.4-7.21,3.72,3.72,0,0,1-3.29-4l2.49-21.43A3.94,3.94,0,0,1,289.23,304.83Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.43,333.41a236.58,236.58,0,0,1,35.4,7.21,3.85,3.85,0,0,0,2.62-.19A217.2,217.2,0,0,0,307,319.25a223.35,223.35,0,0,0-23.86,13A3.78,3.78,0,0,0,285.43,333.41Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.43,333.41a236.58,236.58,0,0,1,35.4,7.21,3.85,3.85,0,0,0,2.62-.19A217.2,217.2,0,0,0,307,319.25a223.35,223.35,0,0,0-23.86,13A3.78,3.78,0,0,0,285.43,333.41Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.85,324.38A237,237,0,0,1,331.06,314a4.66,4.66,0,0,0-1.9-1.07,268.12,268.12,0,0,0-39.93-8.12,4.52,4.52,0,0,0-2.18.24A227.23,227.23,0,0,1,305.85,324.38Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.85,324.38A237,237,0,0,1,331.06,314a4.66,4.66,0,0,0-1.9-1.07,268.12,268.12,0,0,0-39.93-8.12,4.52,4.52,0,0,0-2.18.24A227.23,227.23,0,0,1,305.85,324.38Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.21,236.37a171.18,171.18,0,0,0-9.34,18.81,191.85,191.85,0,0,1,29.87-12.62A184.18,184.18,0,0,0,175.21,236.37Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.8,253.7A192.31,192.31,0,0,1,194,242.21a2.9,2.9,0,0,1,3.75,1.55q2.5,7.45,5,14.9A2.68,2.68,0,0,1,201,262a171.28,171.28,0,0,0-24.1,10.18,2.81,2.81,0,0,1-3.7-1l-7.8-13.73A2.75,2.75,0,0,1,166.8,253.7Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.8,253.7A192.31,192.31,0,0,1,194,242.21a2.9,2.9,0,0,1,3.75,1.55q2.5,7.45,5,14.9A2.68,2.68,0,0,1,201,262a171.28,171.28,0,0,0-24.1,10.18,2.81,2.81,0,0,1-3.7-1l-7.8-13.73A2.75,2.75,0,0,1,166.8,253.7Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.92,272.19A172.47,172.47,0,0,1,201,262a2.7,2.7,0,0,0,1.48-1.18A165.28,165.28,0,0,0,183.55,255,156.44,156.44,0,0,0,175,272.44,2.75,2.75,0,0,0,176.92,272.19Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.92,272.19A172.47,172.47,0,0,1,201,262a2.7,2.7,0,0,0,1.48-1.18A165.28,165.28,0,0,0,183.55,255,156.44,156.44,0,0,0,175,272.44,2.75,2.75,0,0,0,176.92,272.19Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.12,258.5a161.62,161.62,0,0,1,10.46-16.43,3.35,3.35,0,0,0-1.59.14A191.15,191.15,0,0,0,166.8,253.7a3.24,3.24,0,0,0-1.19,1A173.52,173.52,0,0,1,185.12,258.5Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.12,258.5a161.62,161.62,0,0,1,10.46-16.43,3.35,3.35,0,0,0-1.59.14A191.15,191.15,0,0,0,166.8,253.7a3.24,3.24,0,0,0-1.19,1A173.52,173.52,0,0,1,185.12,258.5Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402,271.44c-1.19-.43-2.4-.85-3.61-1.26l.29-.83c1.22.41,2.44.83,3.64,1.27Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.59,269.28c-2.74-.84-5.55-1.61-8.34-2.28l.21-.85c2.82.67,5.65,1.45,8.41,2.3Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.7,269.13a124.06,124.06,0,0,0-6.59,13.28,136.32,136.32,0,0,1,21.09-8.91A132.17,132.17,0,0,0,386.7,269.13Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.77,281.37A136.62,136.62,0,0,1,400,273.25a2.06,2.06,0,0,1,2.65,1.1l3.54,10.52a1.88,1.88,0,0,1-1.22,2.36,120.72,120.72,0,0,0-17,7.19,2,2,0,0,1-2.61-.74q-2.74-4.85-5.51-9.68A2,2,0,0,1,380.77,281.37Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.77,281.37A136.62,136.62,0,0,1,400,273.25a2.06,2.06,0,0,1,2.65,1.1l3.54,10.52a1.88,1.88,0,0,1-1.22,2.36,120.72,120.72,0,0,0-17,7.19,2,2,0,0,1-2.61-.74q-2.74-4.85-5.51-9.68A2,2,0,0,1,380.77,281.37Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.92,294.42a121.79,121.79,0,0,1,17-7.19,1.92,1.92,0,0,0,1-.83,117.59,117.59,0,0,0-13.37-4.11,110,110,0,0,0-6,12.31A2,2,0,0,0,387.92,294.42Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.92,294.42a121.79,121.79,0,0,1,17-7.19,1.92,1.92,0,0,0,1-.83,117.59,117.59,0,0,0-13.37-4.11,110,110,0,0,0-6,12.31A2,2,0,0,0,387.92,294.42Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.7,284.76a115.63,115.63,0,0,1,7.38-11.6,2.4,2.4,0,0,0-1.12.09,137.77,137.77,0,0,0-19.19,8.11,2.33,2.33,0,0,0-.84.74A119.35,119.35,0,0,1,393.7,284.76Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.7,284.76a115.63,115.63,0,0,1,7.38-11.6,2.4,2.4,0,0,0-1.12.09,137.77,137.77,0,0,0-19.19,8.11,2.33,2.33,0,0,0-.84.74A119.35,119.35,0,0,1,393.7,284.76Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "338.62 259.55 352.53 270.04 322.15 268.13 338.62 259.55",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.18,269.3l-27.51-1.73c-1.56-.1-3,.7-3.1,1.76L319,280.87c-.14,1.06,1,2,2.58,2.12l27.51,1.73c1.56.09,3-.7,3.1-1.77l1.56-11.53C353.9,270.35,352.74,269.4,351.18,269.3Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.18,269.3l-27.51-1.73c-1.56-.1-3,.7-3.1,1.76L319,280.87c-.14,1.06,1,2,2.58,2.12l27.51,1.73c1.56.09,3-.7,3.1-1.77l1.56-11.53C353.9,270.35,352.74,269.4,351.18,269.3Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.1,284.72,321.59,283a3.53,3.53,0,0,1-1.8-.6l16.81-7.88L351,284.35A3.88,3.88,0,0,1,349.1,284.72Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.1,284.72,321.59,283a3.53,3.53,0,0,1-1.8-.6l16.81-7.88L351,284.35A3.88,3.88,0,0,1,349.1,284.72Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.23,277.32l-14-9.57a3.89,3.89,0,0,1,1.47-.18l27.51,1.73a3.61,3.61,0,0,1,1.4.36Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.23,277.32l-14-9.57a3.89,3.89,0,0,1,1.47-.18l27.51,1.73a3.61,3.61,0,0,1,1.4.36Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.12,286.51A245.32,245.32,0,0,0,259,302.43a263.54,263.54,0,0,1,43.94,4.92A238.18,238.18,0,0,0,283.12,286.51Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.11,301.3a265.45,265.45,0,0,1,40,4.48,3.8,3.8,0,0,1,3.32,4.3q-2.28,10.41-4.55,20.82a3.74,3.74,0,0,1-4.38,2.78,235.55,235.55,0,0,0-35.44-4,3.69,3.69,0,0,1-3.61-3.67l.45-21.28A3.86,3.86,0,0,1,261.11,301.3Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.11,301.3a265.45,265.45,0,0,1,40,4.48,3.8,3.8,0,0,1,3.32,4.3q-2.28,10.41-4.55,20.82a3.74,3.74,0,0,1-4.38,2.78,235.55,235.55,0,0,0-35.44-4,3.69,3.69,0,0,1-3.61-3.67l.45-21.28A3.86,3.86,0,0,1,261.11,301.3Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260,329.72a235.54,235.54,0,0,1,35.44,4,3.74,3.74,0,0,0,2.56-.41,216,216,0,0,0-18.17-19.36,219.71,219.71,0,0,0-22.23,14.84A3.76,3.76,0,0,0,260,329.72Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260,329.72a235.54,235.54,0,0,1,35.44,4,3.74,3.74,0,0,0,2.56-.41,216,216,0,0,0-18.17-19.36,219.71,219.71,0,0,0-22.23,14.84A3.76,3.76,0,0,0,260,329.72Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.26,319.05a230.83,230.83,0,0,1,23.79-12.39,4.4,4.4,0,0,0-2-.88,264.17,264.17,0,0,0-40-4.48,4.53,4.53,0,0,0-2.12.43A226.68,226.68,0,0,1,279.26,319.05Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.26,319.05a230.83,230.83,0,0,1,23.79-12.39,4.4,4.4,0,0,0-2-.88,264.17,264.17,0,0,0-40-4.48,4.53,4.53,0,0,0-2.12.43A226.68,226.68,0,0,1,279.26,319.05Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.75,372.32,359,353.83a3.8,3.8,0,0,0-5.13,1.17l-11.69,18.32a3.58,3.58,0,0,0,1.2,5l30.71,18.48a3.79,3.79,0,0,0,5.13-1.17L391,377.31A3.58,3.58,0,0,0,389.75,372.32Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.75,372.32,359,353.83a3.8,3.8,0,0,0-5.13,1.17l-11.69,18.32a3.58,3.58,0,0,0,1.2,5l30.71,18.48a3.79,3.79,0,0,0,5.13-1.17L391,377.31A3.58,3.58,0,0,0,389.75,372.32Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.12,396.79l-30.7-18.48a3.62,3.62,0,0,1-1.59-2l26.41-3.57,8.46,24.56A3.72,3.72,0,0,1,374.12,396.79Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.12,396.79l-30.7-18.48a3.62,3.62,0,0,1-1.59-2l26.41-3.57,8.46,24.56A3.72,3.72,0,0,1,374.12,396.79Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.4,377.18l-8.23-23.89a3.74,3.74,0,0,1,1.87.54l30.7,18.49a3.64,3.64,0,0,1,1.34,1.39Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.26,320.91l-25.84-15.56a3.2,3.2,0,0,0-4.32,1l-9.84,15.42a3,3,0,0,0,1,4.2l25.84,15.56a3.21,3.21,0,0,0,4.33-1l9.84-15.41A3,3,0,0,0,335.26,320.91Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.26,320.91l-25.84-15.56a3.2,3.2,0,0,0-4.32,1l-9.84,15.42a3,3,0,0,0,1,4.2l25.84,15.56a3.21,3.21,0,0,0,4.33-1l9.84-15.41A3,3,0,0,0,335.26,320.91Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.11,341.51,296.27,326a3,3,0,0,1-1.34-1.7l22.23-3,7.12,20.67A3.12,3.12,0,0,1,322.11,341.51Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.11,341.51,296.27,326a3,3,0,0,1-1.34-1.7l22.23-3,7.12,20.67A3.12,3.12,0,0,1,322.11,341.51Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.77,325l-6.93-20.1a3,3,0,0,1,1.58.45l25.84,15.56a3,3,0,0,1,1.12,1.17Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.3,346.5l-18.44,4.71a1.92,1.92,0,0,0-1.41,2.34l3,11a2,2,0,0,0,2.4,1.36l18.44-4.71a1.92,1.92,0,0,0,1.41-2.34l-3-11A2,2,0,0,0,387.3,346.5Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.3,346.5l-18.44,4.71a1.92,1.92,0,0,0-1.41,2.34l3,11a2,2,0,0,0,2.4,1.36l18.44-4.71a1.92,1.92,0,0,0,1.41-2.34l-3-11A2,2,0,0,0,387.3,346.5Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.28,361.2l-18.44,4.71a1.89,1.89,0,0,1-1.37-.14l8.18-11.12,12.76,5.77A1.93,1.93,0,0,1,391.28,361.2Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.28,361.2l-18.44,4.71a1.89,1.89,0,0,1-1.37-.14l8.18-11.12,12.76,5.77A1.93,1.93,0,0,1,391.28,361.2Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.37,357.32,368,351.71a2,2,0,0,1,.9-.5l18.44-4.72a2,2,0,0,1,1,0Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.12,353.64l-30.39-4.51a3.17,3.17,0,0,0-3.62,2.58l-2.85,18.13a3.09,3.09,0,0,0,2.66,3.51l30.39,4.52a3.19,3.19,0,0,0,3.62-2.58l2.85-18.14A3.11,3.11,0,0,0,187.12,353.64Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.12,353.64l-30.39-4.51a3.17,3.17,0,0,0-3.62,2.58l-2.85,18.13a3.09,3.09,0,0,0,2.66,3.51l30.39,4.52a3.19,3.19,0,0,0,3.62-2.58l2.85-18.14A3.11,3.11,0,0,0,187.12,353.64Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.31,377.87l-30.39-4.51a3.18,3.18,0,0,1-1.95-1.07l19.45-11.36,15.07,16.49A3.19,3.19,0,0,1,183.31,377.87Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.31,377.87l-30.39-4.51a3.18,3.18,0,0,1-1.95-1.07l19.45-11.36,15.07,16.49A3.19,3.19,0,0,1,183.31,377.87Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.73,365.34l-14.65-16a3.27,3.27,0,0,1,1.65-.19l30.39,4.52a3.08,3.08,0,0,1,1.52.66Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.38,350.14c-12.4,2.68-25.34,3.34-37.73,6a3.71,3.71,0,0,0-2.83,4.59q3,11,5.93,22a4.09,4.09,0,0,0,4.82,2.8c12.4-2.67,25.34-3.34,37.74-6a3.71,3.71,0,0,0,2.82-4.59q-3-11-5.93-22A4.09,4.09,0,0,0,346.38,350.14Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.38,350.14c-12.4,2.68-25.34,3.34-37.73,6a3.71,3.71,0,0,0-2.83,4.59q3,11,5.93,22a4.09,4.09,0,0,0,4.82,2.8c12.4-2.67,25.34-3.34,37.74-6a3.71,3.71,0,0,0,2.82-4.59q-3-11-5.93-22A4.09,4.09,0,0,0,346.38,350.14Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.31,379.5c-12.4,2.67-25.34,3.34-37.74,6a4.13,4.13,0,0,1-2.76-.35c5.48-7.3,11.15-13.87,16.83-20.44,8.71,4.67,17.42,9.35,25.94,13.29A3.69,3.69,0,0,1,354.31,379.5Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.31,379.5c-12.4,2.67-25.34,3.34-37.74,6a4.13,4.13,0,0,1-2.76-.35c5.48-7.3,11.15-13.87,16.83-20.44,8.71,4.67,17.42,9.35,25.94,13.29A3.69,3.69,0,0,1,354.31,379.5Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.08,370.06c-8.47-4.55-16.94-9.09-25.23-13a3.7,3.7,0,0,1,1.79-1c12.4-2.67,25.34-3.34,37.74-6a4.29,4.29,0,0,1,2.08.08C343.12,357.28,337.6,363.67,332.08,370.06Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.81,322.45a248.67,248.67,0,0,1,24.46,16.13,267.08,267.08,0,0,0-44.5,5A245.76,245.76,0,0,1,281.81,322.45Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.11,337.44a268.6,268.6,0,0,0-40.5,4.53,3.86,3.86,0,0,0-3.36,4.36q2.31,10.55,4.61,21.08a3.79,3.79,0,0,0,4.43,2.82,237.76,237.76,0,0,1,35.9-4,3.75,3.75,0,0,0,3.66-3.73l-.45-21.55A3.92,3.92,0,0,0,304.11,337.44Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.11,337.44a268.6,268.6,0,0,0-40.5,4.53,3.86,3.86,0,0,0-3.36,4.36q2.31,10.55,4.61,21.08a3.79,3.79,0,0,0,4.43,2.82,237.76,237.76,0,0,1,35.9-4,3.75,3.75,0,0,0,3.66-3.73l-.45-21.55A3.92,3.92,0,0,0,304.11,337.44Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.19,366.22a237.63,237.63,0,0,0-35.9,4,3.89,3.89,0,0,1-2.59-.42,218.88,218.88,0,0,1,18.41-19.61,222.46,222.46,0,0,1,22.51,15A3.85,3.85,0,0,1,305.19,366.22Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.19,366.22a237.63,237.63,0,0,0-35.9,4,3.89,3.89,0,0,1-2.59-.42,218.88,218.88,0,0,1,18.41-19.61,222.46,222.46,0,0,1,22.51,15A3.85,3.85,0,0,1,305.19,366.22Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.72,355.42a232.66,232.66,0,0,0-24.09-12.55,4.4,4.4,0,0,1,2-.9,268.62,268.62,0,0,1,40.49-4.53,4.6,4.6,0,0,1,2.15.43A229.51,229.51,0,0,0,285.72,355.42Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.72,355.42a232.66,232.66,0,0,0-24.09-12.55,4.4,4.4,0,0,1,2-.9,268.62,268.62,0,0,1,40.49-4.53,4.6,4.6,0,0,1,2.15.43A229.51,229.51,0,0,0,285.72,355.42Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.9,345.21l-35.7,5.38a3.64,3.64,0,0,0-3.11,4.13l3.4,21.3a3.71,3.71,0,0,0,4.25,3l35.7-5.37a3.66,3.66,0,0,0,3.12-4.14l-3.4-21.29A3.74,3.74,0,0,0,293.9,345.21Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.9,345.21l-35.7,5.38a3.64,3.64,0,0,0-3.11,4.13l3.4,21.3a3.71,3.71,0,0,0,4.25,3l35.7-5.37a3.66,3.66,0,0,0,3.12-4.14l-3.4-21.29A3.74,3.74,0,0,0,293.9,345.21Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.44,373.67l-35.69,5.38a3.78,3.78,0,0,1-2.57-.53l17.66-19.41,22.88,13.3A3.66,3.66,0,0,1,298.44,373.67Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.44,373.67l-35.69,5.38a3.78,3.78,0,0,1-2.57-.53l17.66-19.41,22.88,13.3A3.66,3.66,0,0,1,298.44,373.67Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.67,364.29l-22.25-12.93a3.68,3.68,0,0,1,1.78-.77l35.7-5.38a3.72,3.72,0,0,1,1.94.22Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "304.17 388.98 273.3 379.64 285.87 340.45 316.74 349.8 304.17 388.98",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "311.47 357.5 285.7 349.71 286.33 347.75 312.09 355.55 311.47 357.5",
    style: {
      fill: "#FF0000",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "299.26 360.44 283.76 355.75 284.39 353.8 299.89 358.49 299.26 360.44",
    style: {
      fill: "#FF0000",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "307.17 362.83 302.09 361.3 302.72 359.35 307.79 360.88 307.17 362.83",
    style: {
      fill: "#FF0000",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "307.59 369.59 281.82 361.79 282.45 359.84 308.21 367.64 307.59 369.59",
    style: {
      fill: "#FF0000",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "299.95 373.91 279.88 367.84 280.51 365.88 300.57 371.96 299.95 373.91",
    style: {
      fill: "#FF0000",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "303.71 381.68 288.57 377.09 289.19 375.14 304.34 379.73 303.71 381.68",
    style: {
      fill: "#FF0000",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "277.95 373.88 286.05 376.33 286.68 374.38 278.57 371.93 277.95 373.88",
    style: {
      fill: "#FF0000",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "261.77 315.45 274.04 334.57 241.11 325.71 261.77 315.45",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.77,333.16l-29.82-8a3.22,3.22,0,0,0-3.94,2.16l-5.07,17.79a3.1,3.1,0,0,0,2.22,3.82l29.83,8a3.22,3.22,0,0,0,3.93-2.16L275,337A3.1,3.1,0,0,0,272.77,333.16Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.77,333.16l-29.82-8a3.22,3.22,0,0,0-3.94,2.16l-5.07,17.79a3.1,3.1,0,0,0,2.22,3.82l29.83,8a3.22,3.22,0,0,0,3.93-2.16L275,337A3.1,3.1,0,0,0,272.77,333.16Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266,356.93l-29.82-8a3.15,3.15,0,0,1-1.81-1.3l20.84-9.1,13,18.22A3.23,3.23,0,0,1,266,356.93Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266,356.93l-29.82-8a3.15,3.15,0,0,1-1.81-1.3l20.84-9.1,13,18.22A3.23,3.23,0,0,1,266,356.93Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254,342.84l-12.68-17.71a3.19,3.19,0,0,1,1.68,0l29.82,8a3.15,3.15,0,0,1,1.44.83Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254,342.84l-12.68-17.71a3.19,3.19,0,0,1,1.68,0l29.82,8a3.15,3.15,0,0,1,1.44.83Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.41,351.6c-11.89-1.86-23.55-5.67-35.44-7.53a3.61,3.61,0,0,0-4.15,3.09l-2.67,21.39a3.78,3.78,0,0,0,3.24,4.11c11.9,1.86,23.55,5.67,35.45,7.52a3.61,3.61,0,0,0,4.14-3.09q1.33-10.69,2.68-21.39A3.76,3.76,0,0,0,263.41,351.6Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.41,351.6c-11.89-1.86-23.55-5.67-35.44-7.53a3.61,3.61,0,0,0-4.15,3.09l-2.67,21.39a3.78,3.78,0,0,0,3.24,4.11c11.9,1.86,23.55,5.67,35.45,7.52a3.61,3.61,0,0,0,4.14-3.09q1.33-10.69,2.68-21.39A3.76,3.76,0,0,0,263.41,351.6Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.83,380.18c-11.89-1.85-23.54-5.66-35.44-7.52a3.82,3.82,0,0,1-2.31-1.25c7.46-4.58,14.83-8.44,22.2-12.31,6,7.08,12,14.17,18.1,20.54A3.59,3.59,0,0,1,259.83,380.18Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.83,380.18c-11.89-1.85-23.54-5.66-35.44-7.52a3.82,3.82,0,0,1-2.31-1.25c7.46-4.58,14.83-8.44,22.2-12.31,6,7.08,12,14.17,18.1,20.54A3.59,3.59,0,0,1,259.83,380.18Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.63,364.3c-5.83-6.88-11.67-13.77-17.59-20a3.49,3.49,0,0,1,1.93-.23c11.89,1.86,23.55,5.67,35.44,7.52a4.05,4.05,0,0,1,1.81.78C258,356.79,250.8,360.54,243.63,364.3Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.85,361.62a252.39,252.39,0,0,1,25.88,13.88,267,267,0,0,0-43.85,8.93A243.35,243.35,0,0,1,151.85,361.62Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.46,374.56a269,269,0,0,0-39.9,8.12,3.84,3.84,0,0,0-2.93,4.65q3.28,10.29,6.58,20.58a3.81,3.81,0,0,0,4.68,2.41,237.43,237.43,0,0,1,35.37-7.2,3.71,3.71,0,0,0,3.29-4l-2.49-21.42A3.94,3.94,0,0,0,175.46,374.56Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.46,374.56a269,269,0,0,0-39.9,8.12,3.84,3.84,0,0,0-2.93,4.65q3.28,10.29,6.58,20.58a3.81,3.81,0,0,0,4.68,2.41,237.43,237.43,0,0,1,35.37-7.2,3.71,3.71,0,0,0,3.29-4l-2.49-21.42A3.94,3.94,0,0,0,175.46,374.56Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.26,403.12a237.43,237.43,0,0,0-35.37,7.2,3.79,3.79,0,0,1-2.62-.18A217,217,0,0,1,157.75,389a225.76,225.76,0,0,1,23.84,13A3.76,3.76,0,0,1,179.26,403.12Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.26,403.12a237.43,237.43,0,0,0-35.37,7.2,3.79,3.79,0,0,1-2.62-.18A217,217,0,0,1,157.75,389a225.76,225.76,0,0,1,23.84,13A3.76,3.76,0,0,1,179.26,403.12Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.85,394.1a234.35,234.35,0,0,0-25.18-10.35,4.58,4.58,0,0,1,1.89-1.07,267.73,267.73,0,0,1,39.9-8.12,4.64,4.64,0,0,1,2.18.24A230,230,0,0,0,158.85,394.1Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.85,394.1a234.35,234.35,0,0,0-25.18-10.35,4.58,4.58,0,0,1,1.89-1.07,267.73,267.73,0,0,1,39.9-8.12,4.64,4.64,0,0,1,2.18.24A230,230,0,0,0,158.85,394.1Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.47,381.22l41.39,2.49a4.22,4.22,0,0,1,4,4.41l-1.57,24.7a4.25,4.25,0,0,1-4.54,3.89l-41.4-2.49a4.22,4.22,0,0,1-4-4.41l1.58-24.7A4.26,4.26,0,0,1,101.47,381.22Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.47,381.22l41.39,2.49a4.22,4.22,0,0,1,4,4.41l-1.57,24.7a4.25,4.25,0,0,1-4.54,3.89l-41.4-2.49a4.22,4.22,0,0,1-4-4.41l1.58-24.7A4.26,4.26,0,0,1,101.47,381.22Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.37,414.22l41.39,2.5a4.34,4.34,0,0,0,2.87-.87l-22.29-20.38L96.62,413A4.26,4.26,0,0,0,99.37,414.22Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.37,414.22l41.39,2.5a4.34,4.34,0,0,0,2.87-.87l-22.29-20.38L96.62,413A4.26,4.26,0,0,0,99.37,414.22Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121,401.48l24-17.06a4.29,4.29,0,0,0-2.12-.71l-41.4-2.49a4.29,4.29,0,0,0-2.2.44Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.56,313.8l-36.18,7.83a2.22,2.22,0,0,0-1.43,3.62l9.46,14.88a5.27,5.27,0,0,0,5.14,2.2l36.18-7.83a2.22,2.22,0,0,0,1.43-3.62L240.7,316A5.27,5.27,0,0,0,235.56,313.8Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.56,313.8l-36.18,7.83a2.22,2.22,0,0,0-1.43,3.62l9.46,14.88a5.27,5.27,0,0,0,5.14,2.2l36.18-7.83a2.22,2.22,0,0,0,1.43-3.62L240.7,316A5.27,5.27,0,0,0,235.56,313.8Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.35,334.59l-35.42,7.66a5.74,5.74,0,0,1-2.82-.13l12.55-16.24,27.69,7.54A3.21,3.21,0,0,1,248.35,334.59Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.35,334.59l-35.42,7.66a5.74,5.74,0,0,1-2.82-.13l12.55-16.24,27.69,7.54A3.21,3.21,0,0,1,248.35,334.59Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.06,329.64l-26.92-7.33a3.55,3.55,0,0,1,1.62-.76l35.42-7.67a5.87,5.87,0,0,1,2.09,0Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.74,386.56,378,380.88a4,4,0,0,1,4.56,3.25L386.14,407a3.91,3.91,0,0,1-3.35,4.42l-38.25,5.68A4,4,0,0,1,340,413.8L336.4,391A3.9,3.9,0,0,1,339.74,386.56Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.74,386.56,378,380.88a4,4,0,0,1,4.56,3.25L386.14,407a3.91,3.91,0,0,1-3.35,4.42l-38.25,5.68A4,4,0,0,1,340,413.8L336.4,391A3.9,3.9,0,0,1,339.74,386.56Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.54,417.05l38.25-5.68a3.91,3.91,0,0,0,2.44-1.34l-24.47-14.29-19,20.74A4,4,0,0,0,344.54,417.05Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.54,417.05l38.25-5.68a3.91,3.91,0,0,0,2.44-1.34l-24.47-14.29-19,20.74A4,4,0,0,0,344.54,417.05Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.63,401.29l18.44-20.18a4,4,0,0,0-2.08-.23l-38.25,5.68a3.94,3.94,0,0,0-1.91.83Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "156 342.54 135.13 364.93 180.74 360.85 156 342.54",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.15,363.36l41.3-3.7a4.26,4.26,0,0,1,4.66,3.76l2.34,24.64a4.21,4.21,0,0,1-3.88,4.52l-41.29,3.7a4.26,4.26,0,0,1-4.66-3.76l-2.34-24.64A4.21,4.21,0,0,1,137.15,363.36Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.15,363.36l41.3-3.7a4.26,4.26,0,0,1,4.66,3.76l2.34,24.64a4.21,4.21,0,0,1-3.88,4.52l-41.29,3.7a4.26,4.26,0,0,1-4.66-3.76l-2.34-24.64A4.21,4.21,0,0,1,137.15,363.36Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.28,396.28l41.29-3.69a4.29,4.29,0,0,0,2.71-1.29L159,374.48l-21.66,21A4.3,4.3,0,0,0,140.28,396.28Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.28,396.28l41.29-3.69a4.29,4.29,0,0,0,2.71-1.29L159,374.48l-21.66,21A4.3,4.3,0,0,0,140.28,396.28Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.6,380.48,180.66,360a4.32,4.32,0,0,0-2.21-.38l-41.29,3.69a4.34,4.34,0,0,0-2.11.77Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.6,380.48,180.66,360a4.32,4.32,0,0,0-2.21-.38l-41.29,3.69a4.34,4.34,0,0,0-2.11.77Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.09,379.79c11.57,2.49,23.65,3.12,35.23,5.61a3.45,3.45,0,0,1,2.63,4.28q-2.76,10.26-5.54,20.51a3.8,3.8,0,0,1-4.49,2.62c-11.58-2.5-23.66-3.12-35.24-5.61a3.46,3.46,0,0,1-2.63-4.29q2.76-10.25,5.54-20.51A3.81,3.81,0,0,1,170.09,379.79Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.09,379.79c11.57,2.49,23.65,3.12,35.23,5.61a3.45,3.45,0,0,1,2.63,4.28q-2.76,10.26-5.54,20.51a3.8,3.8,0,0,1-4.49,2.62c-11.58-2.5-23.66-3.12-35.24-5.61a3.46,3.46,0,0,1-2.63-4.29q2.76-10.25,5.54-20.51A3.81,3.81,0,0,1,170.09,379.79Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.69,407.2c11.57,2.49,23.65,3.11,35.23,5.61a3.93,3.93,0,0,0,2.58-.33c-5.12-6.82-10.42-13-15.72-19.08-8.13,4.36-16.27,8.73-24.22,12.4A3.43,3.43,0,0,0,162.69,407.2Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.69,407.2c11.57,2.49,23.65,3.11,35.23,5.61a3.93,3.93,0,0,0,2.58-.33c-5.12-6.82-10.42-13-15.72-19.08-8.13,4.36-16.27,8.73-24.22,12.4A3.43,3.43,0,0,0,162.69,407.2Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.44,398.38c7.91-4.24,15.82-8.48,23.55-12.1a3.37,3.37,0,0,0-1.67-.88c-11.58-2.5-23.66-3.12-35.23-5.61a4,4,0,0,0-1.94.07C173.13,386.46,178.28,392.42,183.44,398.38Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.1,385.48a172.62,172.62,0,0,0-13.85,15.14,188.58,188.58,0,0,1,31.32-4.07A176.47,176.47,0,0,0,190.1,385.48Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.53,399.48A188.42,188.42,0,0,1,206,395.77a2.77,2.77,0,0,1,3.08,2.42q.3,7.59.61,15.18a2.64,2.64,0,0,1-2.53,2.68,166.31,166.31,0,0,0-25.26,3.29,2.69,2.69,0,0,1-3.17-1.94Q177,410,175.22,402.6A2.72,2.72,0,0,1,177.53,399.48Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.53,399.48A188.42,188.42,0,0,1,206,395.77a2.77,2.77,0,0,1,3.08,2.42q.3,7.59.61,15.18a2.64,2.64,0,0,1-2.53,2.68,166.31,166.31,0,0,0-25.26,3.29,2.69,2.69,0,0,1-3.17-1.94Q177,410,175.22,402.6A2.72,2.72,0,0,1,177.53,399.48Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.92,419.34a166.31,166.31,0,0,1,25.26-3.29,2.71,2.71,0,0,0,1.7-.72A157.72,157.72,0,0,0,192.8,405a152.5,152.5,0,0,0-12.72,14.06A2.75,2.75,0,0,0,181.92,419.34Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.92,419.34a166.31,166.31,0,0,1,25.26-3.29,2.71,2.71,0,0,0,1.7-.72A157.72,157.72,0,0,0,192.8,405a152.5,152.5,0,0,0-12.72,14.06A2.75,2.75,0,0,0,181.92,419.34Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.3,408.68a161.59,161.59,0,0,1,14.24-12.63,3.18,3.18,0,0,0-1.52-.28,188.42,188.42,0,0,0-28.49,3.71,3.15,3.15,0,0,0-1.39.66A164.21,164.21,0,0,1,193.3,408.68Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.3,408.68a161.59,161.59,0,0,1,14.24-12.63,3.18,3.18,0,0,0-1.52-.28,188.42,188.42,0,0,0-28.49,3.71,3.15,3.15,0,0,0-1.39.66A164.21,164.21,0,0,1,193.3,408.68Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.85,351.84a284.64,284.64,0,0,0-28.08,18.52,305.37,305.37,0,0,1,51.09,5.72A279,279,0,0,0,228.85,351.84Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.26,369.05a307.53,307.53,0,0,1,46.49,5.2c2.62.5,4.35,2.77,3.85,5l-5.28,24.2a4.36,4.36,0,0,1-5.09,3.24A273,273,0,0,0,202,402.09a4.3,4.3,0,0,1-4.2-4.28l.52-24.74C198.37,370.78,200.59,369,203.26,369.05Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.26,369.05a307.53,307.53,0,0,1,46.49,5.2c2.62.5,4.35,2.77,3.85,5l-5.28,24.2a4.36,4.36,0,0,1-5.09,3.24A273,273,0,0,0,202,402.09a4.3,4.3,0,0,1-4.2-4.28l.52-24.74C198.37,370.78,200.59,369,203.26,369.05Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202,402.09a273,273,0,0,1,41.22,4.61,4.48,4.48,0,0,0,3-.47,249.81,249.81,0,0,0-21.14-22.52A255.89,255.89,0,0,0,199.22,401,4.35,4.35,0,0,0,202,402.09Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202,402.09a273,273,0,0,1,41.22,4.61,4.48,4.48,0,0,0,3-.47,249.81,249.81,0,0,0-21.14-22.52A255.89,255.89,0,0,0,199.22,401,4.35,4.35,0,0,0,202,402.09Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.36,389.69A267.12,267.12,0,0,1,252,375.28a5.24,5.24,0,0,0-2.28-1,307.39,307.39,0,0,0-46.49-5.2,5.19,5.19,0,0,0-2.47.5A263.15,263.15,0,0,1,224.36,389.69Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.36,389.69A267.12,267.12,0,0,1,252,375.28a5.24,5.24,0,0,0-2.28-1,307.39,307.39,0,0,0-46.49-5.2,5.19,5.19,0,0,0-2.47.5A263.15,263.15,0,0,1,224.36,389.69Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215,378l41,6.17a4.18,4.18,0,0,1,3.57,4.75l-3.9,24.45a4.29,4.29,0,0,1-4.89,3.48l-41-6.18a4.18,4.18,0,0,1-3.58-4.74l3.91-24.45A4.28,4.28,0,0,1,215,378Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215,378l41,6.17a4.18,4.18,0,0,1,3.57,4.75l-3.9,24.45a4.29,4.29,0,0,1-4.89,3.48l-41-6.18a4.18,4.18,0,0,1-3.58-4.74l3.91-24.45A4.28,4.28,0,0,1,215,378Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.76,410.65l41,6.17a4.33,4.33,0,0,0,2.95-.61l-20.28-22.28L207.14,409.2A4.26,4.26,0,0,0,209.76,410.65Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.76,410.65l41,6.17a4.33,4.33,0,0,0,2.95-.61l-20.28-22.28L207.14,409.2A4.26,4.26,0,0,0,209.76,410.65Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.46,399.88,258,385a4.29,4.29,0,0,0-2-.9L215,378a4.33,4.33,0,0,0-2.24.25Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "251.87 343.8 237.77 365.76 275.59 355.58 251.87 343.8",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.24,364.13l34.24-9.21A3.68,3.68,0,0,1,278,357.4l5.83,20.43a3.56,3.56,0,0,1-2.56,4.38L247,391.43a3.7,3.7,0,0,1-4.51-2.48l-5.83-20.43A3.57,3.57,0,0,1,239.24,364.13Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.24,364.13l34.24-9.21A3.68,3.68,0,0,1,278,357.4l5.83,20.43a3.56,3.56,0,0,1-2.56,4.38L247,391.43a3.7,3.7,0,0,1-4.51-2.48l-5.83-20.43A3.57,3.57,0,0,1,239.24,364.13Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247,391.43l34.23-9.22a3.63,3.63,0,0,0,2.08-1.48l-23.92-10.45-15,20.92A3.73,3.73,0,0,0,247,391.43Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247,391.43l34.23-9.22a3.63,3.63,0,0,0,2.08-1.48l-23.92-10.45-15,20.92A3.73,3.73,0,0,0,247,391.43Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.84,375.25l14.56-20.34a3.72,3.72,0,0,0-1.93,0l-34.23,9.21a3.77,3.77,0,0,0-1.66,1Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.84,375.25l14.56-20.34a3.72,3.72,0,0,0-1.93,0l-34.23,9.21a3.77,3.77,0,0,0-1.66,1Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250,385.3c13.66-2.13,27-6.5,40.69-8.63a4.14,4.14,0,0,1,4.76,3.54q1.54,12.29,3.07,24.56a4.34,4.34,0,0,1-3.72,4.72c-13.66,2.13-27,6.5-40.7,8.63a4.15,4.15,0,0,1-4.76-3.54q-1.53-12.29-3.07-24.56A4.34,4.34,0,0,1,250,385.3Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250,385.3c13.66-2.13,27-6.5,40.69-8.63a4.14,4.14,0,0,1,4.76,3.54q1.54,12.29,3.07,24.56a4.34,4.34,0,0,1-3.72,4.72c-13.66,2.13-27,6.5-40.7,8.63a4.15,4.15,0,0,1-4.76-3.54q-1.53-12.29-3.07-24.56A4.34,4.34,0,0,1,250,385.3Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.09,418.12c13.65-2.13,27-6.5,40.69-8.63a4.55,4.55,0,0,0,2.66-1.43c-8.57-5.26-17-9.7-25.5-14.14-6.89,8.13-13.78,16.27-20.77,23.58A4.11,4.11,0,0,0,254.09,418.12Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.09,418.12c13.65-2.13,27-6.5,40.69-8.63a4.55,4.55,0,0,0,2.66-1.43c-8.57-5.26-17-9.7-25.5-14.14-6.89,8.13-13.78,16.27-20.77,23.58A4.11,4.11,0,0,0,254.09,418.12Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.69,399.89c6.7-7.91,13.4-15.81,20.2-23a4.14,4.14,0,0,0-2.22-.26c-13.66,2.13-27,6.51-40.69,8.64a4.58,4.58,0,0,0-2.08.89C256.23,391.26,264.46,395.58,272.69,399.89Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.33,363.52a287.3,287.3,0,0,0-29.72,15.94A306.27,306.27,0,0,1,343,389.7,277.62,277.62,0,0,0,322.33,363.52Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.22,378.38A307.29,307.29,0,0,1,341,387.7c2.56.73,4.07,3.15,3.37,5.33l-7.55,23.63a4.39,4.39,0,0,1-5.38,2.77,273.34,273.34,0,0,0-40.6-8.27,4.25,4.25,0,0,1-3.78-4.63l2.85-24.59C290.19,379.67,292.57,378,295.22,378.38Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.22,378.38A307.29,307.29,0,0,1,341,387.7c2.56.73,4.07,3.15,3.37,5.33l-7.55,23.63a4.39,4.39,0,0,1-5.38,2.77,273.34,273.34,0,0,0-40.6-8.27,4.25,4.25,0,0,1-3.78-4.63l2.85-24.59C290.19,379.67,292.57,378,295.22,378.38Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.86,411.17a272,272,0,0,1,40.6,8.26,4.4,4.4,0,0,0,3-.21,249,249,0,0,0-18.93-24.3,257.87,257.87,0,0,0-27.37,14.88A4.4,4.4,0,0,0,290.86,411.17Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.86,411.17a272,272,0,0,1,40.6,8.26,4.4,4.4,0,0,0,3-.21,249,249,0,0,0-18.93-24.3,257.87,257.87,0,0,0-27.37,14.88A4.4,4.4,0,0,0,290.86,411.17Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.28,400.81a270,270,0,0,1,28.92-11.88A5.09,5.09,0,0,0,341,387.7a308.58,308.58,0,0,0-45.8-9.33,5.36,5.36,0,0,0-2.51.28A260.89,260.89,0,0,1,314.28,400.81Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.28,400.81a270,270,0,0,1,28.92-11.88A5.09,5.09,0,0,0,341,387.7a308.58,308.58,0,0,0-45.8-9.33,5.36,5.36,0,0,0-2.51.28A260.89,260.89,0,0,1,314.28,400.81Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.52,296.75a248.23,248.23,0,0,0-13.29,26.76,271.65,271.65,0,0,1,42.51-18A261.87,261.87,0,0,0,168.52,296.75Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.57,321.4a274,274,0,0,1,38.67-16.35,4.13,4.13,0,0,1,5.34,2.21l7.13,21.2a3.8,3.8,0,0,1-2.46,4.76A242.66,242.66,0,0,0,171,347.71a4,4,0,0,1-5.26-1.49L154.6,326.7A3.91,3.91,0,0,1,156.57,321.4Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.57,321.4a274,274,0,0,1,38.67-16.35,4.13,4.13,0,0,1,5.34,2.21l7.13,21.2a3.8,3.8,0,0,1-2.46,4.76A242.66,242.66,0,0,0,171,347.71a4,4,0,0,1-5.26-1.49L154.6,326.7A3.91,3.91,0,0,1,156.57,321.4Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171,347.71a243.15,243.15,0,0,1,34.29-14.49,3.93,3.93,0,0,0,2.1-1.68,234.23,234.23,0,0,0-26.95-8.28,220.62,220.62,0,0,0-12.14,24.8A4,4,0,0,0,171,347.71Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171,347.71a243.15,243.15,0,0,1,34.29-14.49,3.93,3.93,0,0,0,2.1-1.68,234.23,234.23,0,0,0-26.95-8.28,220.62,220.62,0,0,0-12.14,24.8A4,4,0,0,0,171,347.71Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.62,328.23a231.35,231.35,0,0,1,14.88-23.38,4.77,4.77,0,0,0-2.26.2,275.07,275.07,0,0,0-38.67,16.34,4.62,4.62,0,0,0-1.69,1.48A244.79,244.79,0,0,1,182.62,328.23Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.62,328.23a231.35,231.35,0,0,1,14.88-23.38,4.77,4.77,0,0,0-2.26.2,275.07,275.07,0,0,0-38.67,16.34,4.62,4.62,0,0,0-1.69,1.48A244.79,244.79,0,0,1,182.62,328.23Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202,358.88l-30.28,11c-9.79-11.05-5-27.39-14.81-38.44l30.28-11C196.93,331.49,192.17,347.83,202,358.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.84,352l-25.27,9.19c.24.64.5,1.27.79,1.89l25.27-9.18C195.35,353.25,195.08,352.62,194.84,352Z",
    style: {
      fill: "#FF0000",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183,349.52l-15.21,5.53q.22,1,.48,2l15.21-5.53Q183.24,350.54,183,349.52Z",
    style: {
      fill: "#FF0000",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.76,346.7l-5,1.81q.22,1,.48,2l5-1.81Q191,347.72,190.76,346.7Z",
    style: {
      fill: "#FF0000",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.85,339.55l-25.27,9.19c.12.68.25,1.36.37,2l25.28-9.19C192.1,340.91,192,340.23,191.85,339.55Z",
    style: {
      fill: "#FF0000",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.93,335.31l-19.68,7.15q.25,1,.48,2l19.68-7.15Q185.19,336.3,184.93,335.31Z",
    style: {
      fill: "#FF0000",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.45,327.27l-14.85,5.4c.28.62.54,1.25.79,1.89l14.85-5.4C189,328.52,188.74,327.89,188.45,327.27Z",
    style: {
      fill: "#FF0000",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.18,336.46l7.95-2.89c.28.62.55,1.25.79,1.89L164,338.35C163.72,337.71,163.46,337.08,163.18,336.46Z",
    style: {
      fill: "#FF0000",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.86,341.34a249.27,249.27,0,0,1,25.87,13.88,266.65,266.65,0,0,0-43.84,8.92A242,242,0,0,1,198.86,341.34Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.47,354.28a266.47,266.47,0,0,0-39.9,8.12,3.83,3.83,0,0,0-2.93,4.64l6.57,20.58A3.83,3.83,0,0,0,190.9,390a238.7,238.7,0,0,1,35.37-7.2,3.71,3.71,0,0,0,3.29-4l-2.49-21.42C226.85,355.4,224.77,354,222.47,354.28Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.47,354.28a266.47,266.47,0,0,0-39.9,8.12,3.83,3.83,0,0,0-2.93,4.64l6.57,20.58A3.83,3.83,0,0,0,190.9,390a238.7,238.7,0,0,1,35.37-7.2,3.71,3.71,0,0,0,3.29-4l-2.49-21.42C226.85,355.4,224.77,354,222.47,354.28Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.26,382.84A236,236,0,0,0,190.9,390a3.88,3.88,0,0,1-2.63-.19,217.21,217.21,0,0,1,16.48-21.16,221.38,221.38,0,0,1,23.85,13A3.86,3.86,0,0,1,226.26,382.84Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.26,382.84A236,236,0,0,0,190.9,390a3.88,3.88,0,0,1-2.63-.19,217.21,217.21,0,0,1,16.48-21.16,221.38,221.38,0,0,1,23.85,13A3.86,3.86,0,0,1,226.26,382.84Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.86,373.82a233.15,233.15,0,0,0-25.18-10.35,4.47,4.47,0,0,1,1.89-1.08,269.13,269.13,0,0,1,39.89-8.12,4.67,4.67,0,0,1,2.19.25A225.52,225.52,0,0,0,205.86,373.82Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.86,373.82a233.15,233.15,0,0,0-25.18-10.35,4.47,4.47,0,0,1,1.89-1.08,269.13,269.13,0,0,1,39.89-8.12,4.67,4.67,0,0,1,2.19.25A225.52,225.52,0,0,0,205.86,373.82Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.35,319l-.29-.83c2.61-.87,5.28-1.66,7.94-2.35l.23.85C115.59,317.36,112.94,318.14,110.35,319Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.82,318.79a121.84,121.84,0,0,0-13.62,4.41,129.11,129.11,0,0,1,20.13,8A115.51,115.51,0,0,0,118.82,318.79Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.36,322.94a128.34,128.34,0,0,1,18.32,7.31,1.83,1.83,0,0,1,1,2.46l-5,9.27a1.87,1.87,0,0,1-2.46.75A114.46,114.46,0,0,0,102,336.26a1.78,1.78,0,0,1-1.2-2.21q1.56-5,3.13-10A1.94,1.94,0,0,1,106.36,322.94Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.36,322.94a128.34,128.34,0,0,1,18.32,7.31,1.83,1.83,0,0,1,1,2.46l-5,9.27a1.87,1.87,0,0,1-2.46.75A114.46,114.46,0,0,0,102,336.26a1.78,1.78,0,0,1-1.2-2.21q1.56-5,3.13-10A1.94,1.94,0,0,1,106.36,322.94Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102,336.26a114.46,114.46,0,0,1,16.24,6.47,1.88,1.88,0,0,0,1.27.14,104,104,0,0,0-5.94-11.52A108.19,108.19,0,0,0,101,335.49,1.81,1.81,0,0,0,102,336.26Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102,336.26a114.46,114.46,0,0,1,16.24,6.47,1.88,1.88,0,0,0,1.27.14,104,104,0,0,0-5.94-11.52A108.19,108.19,0,0,0,101,335.49,1.81,1.81,0,0,0,102,336.26Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.52,333.7a114.49,114.49,0,0,1,13-2.78,2.17,2.17,0,0,0-.81-.68,129.83,129.83,0,0,0-18.31-7.3,2.31,2.31,0,0,0-1.07-.07A108.39,108.39,0,0,1,112.52,333.7Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.52,333.7a114.49,114.49,0,0,1,13-2.78,2.17,2.17,0,0,0-.81-.68,129.83,129.83,0,0,0-18.31-7.3,2.31,2.31,0,0,0-1.07-.07A108.39,108.39,0,0,1,112.52,333.7Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "342 329.97 360.19 343.68 320.46 341.18 342 329.97",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.42,342.71l-36-2.26c-2-.13-3.87.91-4.06,2.3l-2,15.09c-.19,1.39,1.33,2.64,3.37,2.77l36,2.26c2.05.13,3.87-.91,4.06-2.3l2-15.09C362,344.09,360.46,342.84,358.42,342.71Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.42,342.71l-36-2.26c-2-.13-3.87.91-4.06,2.3l-2,15.09c-.19,1.39,1.33,2.64,3.37,2.77l36,2.26c2.05.13,3.87-.91,4.06-2.3l2-15.09C362,344.09,360.46,342.84,358.42,342.71Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.7,362.87l-36-2.26a4.48,4.48,0,0,1-2.35-.79l22-10.29,18.86,12.86A4.91,4.91,0,0,1,355.7,362.87Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.7,362.87l-36-2.26a4.48,4.48,0,0,1-2.35-.79l22-10.29,18.86,12.86A4.91,4.91,0,0,1,355.7,362.87Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.87,353.19l-18.34-12.51a5.23,5.23,0,0,1,1.92-.23l36,2.26a4.7,4.7,0,0,1,1.83.47Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.87,353.19l-18.34-12.51a5.23,5.23,0,0,1,1.92-.23l36,2.26a4.7,4.7,0,0,1,1.83.47Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--sign-1--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190.86,206.72h0a3.17,3.17,0,0,0,2.74-3.55l-6.79-52.54-6.29.81L187.31,204A3.18,3.18,0,0,0,190.86,206.72Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.52 151.44 186.81 150.63 187.7 157.57 181.47 158.8 180.52 151.44",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "108.17 164.43 110.46 164.04 112.83 164.02 115.14 163.49 117.48 163.28 119.83 163.05 122.17 162.79 124.5 162.42 126.84 162.12 129.19 161.88 131.53 161.6 133.88 161.32 136.21 161.03 138.52 160.52 140.86 160.18 143.18 159.8 145.56 159.79 147.86 159.19 150.21 158.97 152.58 158.85 154.91 158.46 157.25 158.22 159.57 157.8 161.94 157.7 164.26 157.24 166.61 156.98 168.96 156.78 171.27 156.24 173.62 156.05 175.95 155.63 178.29 155.37 180.65 155.15 182.99 154.84 185.31 154.41 187.66 154.13 189.99 153.8 192.34 153.51 194.67 153.17 197.05 153.17 199.38 152.73 201.71 152.37 204.05 152.03 206.41 151.92 208.75 151.54 211.07 151.11 213.4 150.71 215.75 150.53 218.11 150.36 220.45 150.07 222.77 149.62 225.11 149.3 227.47 149.09 229.79 148.65 232.16 148.53 234.51 148.29 236.82 147.73 239.18 147.53 241.54 147.34 243.89 147.11 246.22 146.75 248.58 146.51 250.9 145.99 253.26 145.85 255.6 145.46 257.95 145.18 260.25 144.77 259.85 141.8 259.45 138.78 259.13 135.74 258.7 132.72 258.46 129.67 258.05 126.65 257.49 123.64 257.19 120.6 256.8 117.58 256.52 114.54 256.1 111.52 255.73 108.49 255.14 105.49 254.75 102.47 254.31 99.44 254.03 96.4 253.72 93.36 253.29 90.34 252.94 87.31 252.61 84.27 252.12 81.25 251.63 78.23 251.28 75.2 251.04 72.15 250.43 69.15 250.19 66.09 249.86 63.05 249.21 60.05 248.91 57.06 246.62 57.32 244.26 57.48 241.93 57.82 239.59 58.05 237.27 58.49 234.95 58.91 232.59 59.06 230.27 59.53 227.94 59.88 225.57 60 223.25 60.42 220.9 60.6 218.57 60.95 216.21 61.09 213.9 61.63 211.53 61.66 209.22 62.24 206.86 62.36 204.52 62.67 202.17 62.91 199.87 63.51 197.49 63.49 195.16 63.87 192.82 64.19 190.51 64.66 188.17 64.97 185.82 65.22 183.45 65.33 181.11 65.6 178.81 66.2 176.43 66.22 174.09 66.57 171.77 66.99 169.42 67.21 167.08 67.55 164.74 67.83 162.38 68 160.04 68.32 157.74 68.91 155.39 69.2 153.05 69.52 150.71 69.83 148.34 69.95 146 70.18 143.68 70.67 141.35 71.01 139.02 71.37 136.64 71.44 134.31 71.77 131.95 71.97 129.61 72.3 127.29 72.75 124.93 72.94 122.61 73.41 120.26 73.7 117.89 73.75 115.59 74.38 113.22 74.53 110.88 74.84 108.52 75.04 106.2 75.54 103.83 75.65 101.49 75.97 99.15 76.37 96.84 76.7 97.32 79.66 97.56 82.7 97.95 85.73 98.33 88.76 98.85 91.77 99.17 94.81 99.53 97.84 99.88 100.87 100.19 103.9 100.62 106.92 100.98 109.95 101.38 112.98 101.84 115.99 102.19 119.02 102.64 122.05 102.94 125.08 103.55 128.08 103.84 131.12 104.15 134.17 104.58 137.19 105.13 140.2 105.46 143.24 105.74 146.28 106.15 149.31 106.53 152.34 106.88 155.38 107.42 158.39 107.78 161.44 108.17 164.43",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.17,165a.57.57,0,0,1-.33-.11.55.55,0,0,1-.23-.38l-.75-6-.53-3-.74-6.1-.41-3-.61-6.09-.55-3-.43-3-.61-6.11-.6-2.94-.31-3.1-.44-3-.35-3-.46-3L99.62,104,98.29,91.83l-.51-3L97,82.78l-.24-3.08-.48-2.91a.59.59,0,0,1,.1-.43.57.57,0,0,1,.38-.22l2.31-.33,2.32-.4,2.37-.32,2.41-.12,2.24-.48,2.42-.21,2.32-.31,2.34-.15,2.25-.62.14,0,2.37-.05,2.29-.29,2.28-.46,2.42-.2,2.27-.44,2.36-.34,2.39-.2,2.3-.32,2.44-.07,4.6-.7,2.28-.48,2.41-.25,2.39-.11,7-.92,2.23-.58,2.4-.33,2.39-.18L167,67l2.33-.33,2.38-.22L174,66l2.35-.36,2.38,0,2.24-.58,2.42-.3,2.4-.11,2.32-.24,2.32-.31,2.28-.47,2.38-.32,2.31-.38,2.4,0,2.23-.59,2.43-.25,2.32-.31,2.36-.12,2.25-.57h.13l2.31,0,2.25-.53,2.45-.15,2.28-.35,2.4-.19,2.26-.41,2.44-.12,2.27-.35,2.3-.47,2.43-.15,4.57-.85,2.4-.24,2.3-.34,2.4-.17,2.27-.25a.5.5,0,0,1,.41.12.52.52,0,0,1,.21.38l.3,3,.64,2.94.34,3.1L251,69.1,251.6,72l.25,3.11.35,3,1,6,.69,6.09.43,3,.59,6.11.44,3,.39,3,.58,3,.8,6.09.29,3.06.38,3,.3,3.06.56,3,.41,3.06.25,3.07.42,3,.32,3.06.8,6a.58.58,0,0,1-.46.64l-2.3.4-2.38.29-2.31.39-2.43.14-2.23.51-2.42.25-2.3.36-7.11.62-2.23.55-2.42.26-2.4.12-2.25.43-2.41.22-2.31.31-2.29.45-2.38.29-4.74.35-6.93,1.21-2.43.12-4.62.69-2.3.43h-2.49l-6.94,1-2.35.28-2.29.42-2.37.32-4.71.48-2.28.42-2.42.19-2.22.53-2.44.22-2.33.25-2.27.45-2.45.12-2.25.4L155,159l-2.29.39-2.43.13-2.33.21-2.21.59-.14,0h-2.38l-2.23.38-2.35.34-2.26.5-7.08.86-2.36.24-2.32.3-2.32.37-4.72.5-2.35.2-2.23.52h-.13l-2.37,0-2.19.38ZM97.49,77.18l.39,2.39.24,3.09.77,6,.52,3,1.34,12.18.43,3,.76,6.06.46,3,.35,3.06.45,3,.3,3.07.6,2.94.61,6.14.43,3,.55,3,.33,3.08.29,3,.78,6,.36,3,.53,3,.68,5.48,1.7-.29,2.4,0,2.25-.51,7.1-.71,2.31-.37,2.35-.3,7-.8,2.33-.29,2.26-.5,4.69-.73h2.4l2.23-.59,2.44-.23,2.39-.12,2.26-.39,2.38-.25,2.29-.41,2.43-.11,2.24-.45,2.39-.26,2.37-.2,2.23-.54,2.44-.19,2.27-.42,7.06-.8,2.3-.42,2.38-.28,7-1H197l2.27-.42,4.7-.71,2.42-.12,6.91-1.2,4.77-.36,2.31-.28,2.28-.45,2.38-.32,2.38-.21,2.27-.43,2.44-.13,2.32-.24,2.24-.55,7.15-.63,2.3-.36,2.38-.24,2.25-.52,2.46-.14,2.28-.39,2.38-.29,1.72-.3-.72-5.46-.33-3-.42-3-.24-3.08-.41-3-.56-3-.31-3.09-.38-3L256,114.6l-.79-6-.59-3-.83-6.07-.59-6.11-.43-3L252,84.33l-1-6-.36-3.06-.24-3.06-.6-2.94-.26-3.12-.32-3-.64-2.94-.26-2.49-1.72.2L244.3,58l-2.28.34-2.37.24-4.6.85-2.43.15-2.24.46-2.36.36-2.42.12-2.25.41-2.41.19-2.29.35-2.41.15-2.21.52-.12,0-2.31,0-2.24.56h-.11l-2.36.12-2.29.31-2.37.24-2.21.59-.15,0-2.39,0-2.22.38-2.36.32-2.28.46-2.38.32-2.36.25-2.4.11-2.3.28-2.23.58-.14,0-2.37,0-2.26.34-2.31.42-2.4.22-2.31.34-2.36.28-2.38.18-2.3.31-2.25.58-7.08.93-2.42.12-2.32.24-2.25.48-4.7.7-2.44.08-2.27.32-2.39.2-2.31.33-2.29.44-2.42.2-2.26.46-2.39.3-2.36,0-2.24.62h-.11l-2.36.16-2.3.3-2.39.2-2.25.49-2.46.13-2.3.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.94,
    y: 42.98,
    width: 71.21,
    height: 135.52,
    transform: "translate(261.45 -82.3) rotate(81.43)",
    style: {
      fill: "#FF0000",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.98,
    y: 68.33,
    width: 16.31,
    height: 4.34,
    transform: "translate(389.67 265.26) rotate(-144.62)",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.14,
    y: 148.93,
    width: 16.31,
    height: 4.34,
    transform: "translate(146.82 340.86) rotate(-150.49)",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.31,88.52l12.28-2,.51,3.16L140.41,91l.38,2.35,7.14-1.15.48,3-7.13,1.15.47,2.92L149.66,98l.55,3.36-12.51,2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.74,100.92l-2.4-14.83L158,84.86a11.22,11.22,0,0,1,3.3-.16,3.5,3.5,0,0,1,2,1.06,4.1,4.1,0,0,1,1.08,2.29,4.29,4.29,0,0,1-.18,2.22A4.19,4.19,0,0,1,163,92a5.58,5.58,0,0,1-1.51.85,4.62,4.62,0,0,1,1.28.35,4.9,4.9,0,0,1,.86.66,6.09,6.09,0,0,1,.79.82l2.91,3.94-5.18.83L159,95.27a3.46,3.46,0,0,0-1-1,1.91,1.91,0,0,0-1.18-.16l-.4.06,1,6Zm3.17-9.56,1.94-.31a8,8,0,0,0,1.18-.4,1.28,1.28,0,0,0,.67-.59,1.4,1.4,0,0,0,.15-.9,1.38,1.38,0,0,0-.64-1,2.79,2.79,0,0,0-1.77-.11l-2,.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.85,98.32l-2.39-14.83,7.63-1.23a11.29,11.29,0,0,1,3.31-.16,3.47,3.47,0,0,1,2,1.06,4.25,4.25,0,0,1-.32,6.19,5.82,5.82,0,0,1-1.52.85,4.42,4.42,0,0,1,1.28.35,4.15,4.15,0,0,1,.86.66,5.51,5.51,0,0,1,.79.82L183.44,96l-5.18.83-3.18-4.13a3.45,3.45,0,0,0-1-1,2,2,0,0,0-1.18-.17l-.4.07,1,6ZM172,88.76l1.93-.31a8,8,0,0,0,1.18-.4,1.25,1.25,0,0,0,.67-.59,1.4,1.4,0,0,0,.15-.9,1.38,1.38,0,0,0-.63-1,2.76,2.76,0,0,0-1.78-.11l-2,.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.78,88.48a8.16,8.16,0,0,1,12.44-7.85,7.57,7.57,0,0,1,2.9,5.24,9.32,9.32,0,0,1-.18,4.41,6.38,6.38,0,0,1-2.12,3,8.51,8.51,0,0,1-4,1.59,9.54,9.54,0,0,1-4.28-.13,6.35,6.35,0,0,1-3.07-2.1A8.46,8.46,0,0,1,182.78,88.48Zm4.58-.72a5.07,5.07,0,0,0,1.36,3.09,3.2,3.2,0,0,0,4.56-.72,5.58,5.58,0,0,0,.25-3.58,4.6,4.6,0,0,0-1.34-2.92,3,3,0,0,0-2.45-.6,2.82,2.82,0,0,0-2.06,1.34A5.06,5.06,0,0,0,187.36,87.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.87,93l-2.4-14.83,7.64-1.23a11.29,11.29,0,0,1,3.31-.16,3.44,3.44,0,0,1,2,1.06,4.07,4.07,0,0,1,1.08,2.29,4.24,4.24,0,0,1-.18,2.21A4.15,4.15,0,0,1,212.12,84a5.58,5.58,0,0,1-1.51.85,4.62,4.62,0,0,1,1.28.35,4.43,4.43,0,0,1,.86.66,6.09,6.09,0,0,1,.79.82l2.91,3.94-5.17.83-3.19-4.13a3.34,3.34,0,0,0-1-1,2,2,0,0,0-1.18-.17l-.4.07,1,6ZM205,83.43l1.94-.31a8,8,0,0,0,1.18-.4,1.28,1.28,0,0,0,.67-.59,1.4,1.4,0,0,0,.15-.9,1.37,1.37,0,0,0-.64-1,2.72,2.72,0,0,0-1.77-.11l-2,.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.56,136.44l-17.8,2.88-1.3-8,14.39-24,8.51-1.37,3.49,21.61,4.41-.71,1.23,7.58-4.42.71,1.06,6.57L152.62,143Zm-1.23-7.58-1.78-11.06-7.62,12.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.18,135.82l-29.31,4.73a18.66,18.66,0,0,1,1.74-8.66q1.94-4.23,8.13-10.57a28.58,28.58,0,0,0,4.71-5.74,5.49,5.49,0,0,0,.69-3.33,3.75,3.75,0,0,0-1.63-2.56,4.6,4.6,0,0,0-6,1,7.37,7.37,0,0,0-.93,4.4l-9.91.79a15.86,15.86,0,0,1,1.07-6.78,10,10,0,0,1,3.76-4.25,19.89,19.89,0,0,1,7.53-2.48,21.93,21.93,0,0,1,8.22-.12,9.86,9.86,0,0,1,5.09,2.88,9.62,9.62,0,0,1,2.52,5.19,11.27,11.27,0,0,1-.89,6.44q-1.41,3.24-5.81,7.54c-1.75,1.67-2.91,2.84-3.48,3.49s-1.24,1.49-2,2.51l15.26-2.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.51,127.19,210,124.4a5.22,5.22,0,0,0,1.76,2.66,3.15,3.15,0,0,0,2.37.48,4.1,4.1,0,0,0,3.28-3q.67-1.9.24-7.65a12.16,12.16,0,0,1-3.17,3.22,10.33,10.33,0,0,1-4.13,1.53,10.8,10.8,0,0,1-8.52-2.07,11.84,11.84,0,0,1-4.62-8,12.61,12.61,0,0,1,.63-6.64,10.86,10.86,0,0,1,3.85-5.09,16.18,16.18,0,0,1,7.05-2.65,17.35,17.35,0,0,1,8.76.44,13,13,0,0,1,6,4.93,24.46,24.46,0,0,1,3.59,10.12q1.53,9.52-1.76,14.59T215,133.56a18.66,18.66,0,0,1-6.77.1,10.44,10.44,0,0,1-4.49-2.19A13.19,13.19,0,0,1,200.51,127.19ZM216,108.6a6.58,6.58,0,0,0-2.16-4.24,4.56,4.56,0,0,0-3.76-1.06,4.13,4.13,0,0,0-3,2,6.57,6.57,0,0,0-.58,4.59,6.91,6.91,0,0,0,2.06,4.3,4.28,4.28,0,0,0,3.57,1,4.47,4.47,0,0,0,3.19-2.07A6.28,6.28,0,0,0,216,108.6Z",
    style: {
      fill: "#fff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError429);
export default __webpack_public_path__ + "static/media/Error-429.6851e896a3f72778cb8c49b04aa59433.svg";
export { ForwardRef as ReactComponent };